(function() {
    'use strict';

    angular
        .module('admin.user', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.user')
        .controller('UserAddController', UserAddController);

    function UserAddController($log, $scope, $state, $timeout, $rootScope, $filter, userService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.users = [];
        vm.addUser = addUser;
        vm.user = {};

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  ADD
        //////////////////////
        function addUser() {

            userService.create(vm.user)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("userAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("User Successfully Added!");

                        // push new row to table
                        //vm.users.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        log.debug("userAdd.controller-error:", response);
                        flashService.error("You must enter a name.");
                    }
 
                });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('admin.teamMember', []);

  }
)();

(function() {
    'use strict';

    angular
        .module('admin.teamMember')
        .controller('TeamMemberAddEditController', TeamMemberAddEditController);

    function TeamMemberAddEditController($log, $scope, $state, $timeout, $rootScope, $filter, teamMemberService, formsService, errorResponseService, panelService, flashService, Notification, $stateParams, Upload, AWS_S3_UPLOAD) {
        var vm = this;

        vm.teamMember = {};

        vm.saveTeamMember = saveTeamMember;
        vm.addTeamMember = addTeamMember;
        vm.getTeamMemberById = getTeamMemberById;
        vm.updateTeamMember = updateTeamMember;
        vm.deleteTeamMember = deleteTeamMember;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  INIT
        //////////////////////
        (function(){
            vm.editing = !!$stateParams.id;
            if(vm.editing) getTeamMemberById();
        })();

        //////////////////////
        //  SAVE
        //////////////////////
        function saveTeamMember() {
            // saving a news item add/edit with a changed or new image
            if(!vm.teamMember.imageUrl) {
                uploadThumbnail(vm.imageFile).then(
                    function(response) {
                        vm.teamMember.imageUrl = response.config.url + response.config.data.filename;
                        if(vm.editing) {
                            updateTeamMember();
                        } else {
                            vm.isTeamMemberPending = true;
                            addTeamMember();
                        }
                    },
                    function(err) {
                        $log.debug('Error status: ' + err.status);
                        flashService.error("Failed to upload image.");
                    },
                    function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        vm.progress = progressPercentage;
                        $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    })
            } else {
                // no image added
                if(vm.editing) {
                    updateTeamMember();
                } else if(vm.isTeamMemberPending) {
                    addTeamMember();
                } else {
                    flashService.error("Failed to save TeamMember - a image is required.");
                }
            }
        }

        function uploadThumbnail(file) {
            var cleanedFilename = cleanFilename(vm.teamMember.name);
            var fileExtension = file.name.substr((~-file.name.lastIndexOf(".") >>> 0) + 2);
            var cleanedFilenameAndExtension = cleanedFilename + "." + fileExtension;

            return Upload.upload({
                url: AWS_S3_UPLOAD.s3url,
                method: 'POST',
                data: {
                    key: cleanedFilename + "." + fileExtension, // the key to store the file on S3, could be file name or customized
                    AWSAccessKeyId: AWS_S3_UPLOAD.AWSAccessKeyId,
                    acl: 'public-read', // sets the access to the uploaded file in the bucket: private, public-read, ...
                    policy: AWS_S3_UPLOAD.policy,
                    signature: AWS_S3_UPLOAD.signature, // base64-encoded signature based on policy string (see article below)
                    "Content-Type": file.type != '' ? file.type : 'application/octet-stream', // content type of the file (NotEmpty)
                    filename: cleanedFilenameAndExtension,
                    file: file
                },
                headers: {
                    'Authorization': undefined // we dont want to send auth: bearer JWT for s3 uploads
                }
            });
        }

        function cleanFilename(inputString){
            // get timestamp in milliseconds
            var timestamp = Date.now();
            //filename contains "~!@#$%^&*()_+=`{}[]|\:;'<>,./?Some actual text to keep, maybe...",
            var outputString = inputString.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
            var outputStringWithTimestamp = outputString+'-'+timestamp;
            $log.debug("cleanedFilename-outputStringWithTimestamp", outputStringWithTimestamp);
            return outputStringWithTimestamp;
        }

        //////////////////////
        //  ADD
        //////////////////////
        function addTeamMember() {
            teamMemberService.create(vm.teamMember)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("teamMemberAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("TeamMember Successfully Added!");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("news-item-add.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to add Team Member.")
                        );
                    }

                });
        }

        //////////////////////
        //  EDIT
        //////////////////////
        function getTeamMemberById() {
            teamMemberService.getById($stateParams.id).then(function(response) {
                if (response) {
                    $log.debug('teamMember.edit-getById:', response);

                    vm.teamMember._id = response._id;
                    vm.teamMember.name = response.name;
                    vm.teamMember.imageUrl = response.imageUrl;
                    vm.teamMember.created = response.created;
                }
            });
        }

        function updateTeamMember() {
            teamMemberService.updateById(vm.teamMember)
                .then(function(response) {

                    if (!response.message) {
                        // post success
                        $log.debug("teamMember.edit.controller-success:", response);
                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Team Member Successfully Updated!");
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("teamMember.edit.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to update Team Member.")
                        );
                    }
                });
        }

        function deleteTeamMember() {
            teamMemberService.deleteById(vm.teamMember).then(function(response){
                if(!response.error) {
                    panelService.hide();
                    Notification.success("Team Member Successfully Deleted!");
                    $timeout(function() {
                        $state.reload();
                    });
                } else {
                    Notification.error("Failed to delete Team Member.");
                }
            });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('admin.pressRelease', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.pressRelease')
        .controller('PressReleaseAddEditController', PressReleaseAddEditController);

    function PressReleaseAddEditController($log, $scope, $state, $timeout, $rootScope, $filter, pressReleaseService, 
            formsService, utcDateHelperService, errorResponseService, panelService, metaTagsHelperService,
            flashService, Notification, $stateParams, Upload, AWS_S3_UPLOAD) {

        var vm = this;

        vm.pressRelease = {};
        vm.highlight = {};

        vm.savePressRelease = savePressRelease;
        vm.addPressRelease = addPressRelease;
        vm.getPressReleaseById = getPressReleaseById;
        vm.updatePressRelease = updatePressRelease;
        vm.deletePressRelease = deletePressRelease;
        vm.isTimeValid = isTimeValid;
        vm.getCurrentDate = getCurrentDate;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = function() {
            return formsService.canSave.apply($scope, arguments) && isTimeValid();
        };

        //////////////////////
        //  INIT
        //////////////////////
        (function(){
            vm.editing = !!$stateParams.id;
            if(vm.editing) getPressReleaseById();
        })();

        //////////////////////
        //  SAVE
        //////////////////////
        function savePressRelease() {
            // saving a news item add/edit with a changed or new pdf
            if(!vm.pressRelease.pdfUrl) {
                uploadThumbnail(vm.pdfFile).then(
                    function(response) {
                        vm.pressRelease.pdfUrl = response.config.url + response.config.data.filename;
                        if(vm.editing) {
                            updatePressRelease();
                        } else {
                            vm.isPressReleasePending = true;
                            addPressRelease();
                        }
                    },
                    function(err) {
                        $log.debug('Error status: ' + err.status);
                        flashService.error("Failed to upload image.");
                    },
                    function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        vm.progress = progressPercentage;
                        $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    })
            } else {
                // no pdf added
                if(vm.editing) {
                    updatePressRelease();
                } else if(vm.isPressReleasePending) {
                    addPressRelease();
                } else {
                    flashService.error("Failed to save Press Release - a pdf is required.");
                }
            }
        }

        function uploadThumbnail(file) {
            var cleanedFilename = cleanFilename(vm.pressRelease.title);
            var fileExtension = file.name.substr((~-file.name.lastIndexOf(".") >>> 0) + 2);
            var cleanedFilenameAndExtension = cleanedFilename + "." + fileExtension;

            return Upload.upload({
                url: AWS_S3_UPLOAD.s3url,
                method: 'POST',
                data: {
                    key: cleanedFilename + "." + fileExtension, // the key to store the file on S3, could be file name or customized
                    AWSAccessKeyId: AWS_S3_UPLOAD.AWSAccessKeyId,
                    acl: 'public-read', // sets the access to the uploaded file in the bucket: private, public-read, ...
                    policy: AWS_S3_UPLOAD.policy,
                    signature: AWS_S3_UPLOAD.signature, // base64-encoded signature based on policy string (see article below)
                    "Content-Type": file.type != '' ? file.type : 'application/octet-stream', // content type of the file (NotEmpty)
                    filename: cleanedFilenameAndExtension,
                    file: file
                },
                headers: {
                    'Authorization': undefined // we dont want to send auth: bearer JWT for s3 uploads
                }
            });
        }

        function cleanFilename(inputString){
            // get timestamp in milliseconds
            var timestamp = Date.now();
            //filename contains "~!@#$%^&*()_+=`{}[]|\:;'<>,./?Some actual text to keep, maybe...",
            var outputString = inputString.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
            var outputStringWithTimestamp = outputString+'-'+timestamp;
            $log.debug("cleanedFilename-outputStringWithTimestamp", outputStringWithTimestamp);
            return outputStringWithTimestamp;
        }

        //////////////////////
        //  ADD
        //////////////////////
        function addPressRelease() {
            pressReleaseService.create(vm.pressRelease)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("pressReleaseAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Press Release Successfully Added!");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("news-item-add.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to add Press Release.")
                        );
                    }

                });
        }

        //////////////////////
        //  EDIT
        //////////////////////
        function getPressReleaseById() {
            pressReleaseService.getById($stateParams.id).then(function(response) {
                if (response) {
                    $log.debug('pressRelease.edit-getById:', response);

                    vm.pressRelease._id = response._id;
                    vm.pressRelease.title = response.title;
                    vm.pressRelease.body = response.body;
                    vm.pressRelease.date = response.date;
                    vm.pressRelease.pdfUrl = response.pdfUrl;
                    vm.pressRelease.contactInfo = response.contactInfo;
                    vm.pressRelease.created = response.created;
                    
                    angular.extend(vm.pressRelease, metaTagsHelperService.getMetaViewModel(response));

                    var isDatePast = utcDateHelperService.isDatePast(response.releaseDate);
                    vm.pressRelease.releaseDate = isDatePast ? null : response.releaseDate;

                    vm.highlight.type = 'Press Release';
                    vm.highlight.title = vm.pressRelease.title;
                    vm.highlight.date = vm.pressRelease.date;
                    // we put response id in url to seperate from external links like on news
                    // this is kinda weird, should be changed to something more descriptive
                    vm.highlight.url = vm.pressRelease.metaSlug;
                }
            });
        }

        function updatePressRelease() {
            pressReleaseService.updateById(vm.pressRelease)
                .then(function(response) {

                    if (!response.message) {
                        // post success
                        $log.debug("pressRelease.edit.controller-success:", response);
                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Press Release Successfully Updated!");
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("pressRelease.edit.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to update Press Release.")
                        );
                    }
                });
        }

        function deletePressRelease() {
            pressReleaseService.deleteById(vm.pressRelease).then(function(response){
                if(!response.error) {
                    panelService.hide();
                    Notification.success("Press Release Successfully Deleted!");
                    $timeout(function() {
                        $state.reload();
                    });
                } else {
                    Notification.error("Failed to delete Press Release.");
                }
            });
        }

        function isTimeValid() {
            var releaseDate = vm.pressRelease.releaseDate;
            return !releaseDate || !utcDateHelperService.isDatePast(releaseDate);
        }

        function getCurrentDate() {
            return new Date();
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('admin.newsItem', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.newsItem')
        .controller('NewsItemAddEditController', NewsItemAddEditController);

    function NewsItemAddEditController($log, $scope, $state, $timeout, $rootScope, $filter, newsItemService, utcDateHelperService, formsService, errorResponseService, panelService, flashService, Notification, $stateParams, Upload, AWS_S3_UPLOAD) {
        var vm = this;

        vm.newsItem = {};
        vm.highlight = {};

        vm.saveNewsItem = saveNewsItem;
        vm.addNewsItem = addNewsItem;
        vm.getNewsItemById = getNewsItemById;
        vm.updateNewsItem = updateNewsItem;
        vm.deleteNewsItem = deleteNewsItem;
        vm.isTimeValid = isTimeValid;
        vm.getCurrentDate = getCurrentDate;
        /*
            - if we want to show & validate & use UTC on the admin side instead of local time
            - date stored in the db is always(!) UTC
            vm.minReleaseDate = utcDateHelperService.getCurrentUtcDate();
        */

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = function() {
            return formsService.canSave.apply($scope, arguments) && isTimeValid();
        };

        //////////////////////
        //  INIT
        //////////////////////
        (function(){
            vm.editing = !!$stateParams.id;
            if(vm.editing) getNewsItemById();
        })();

        //////////////////////
        //  SAVE
        //////////////////////
        function saveNewsItem() {
            // saving a news item add/edit with a changed or new thumbnail
            if(!vm.newsItem.thumbnailUrl) {
                uploadThumbnail(vm.thumbnailFile).then(
                    function(response) {
                        vm.newsItem.thumbnailUrl = response.config.url + response.config.data.filename;
                        if(vm.editing) {
                            updateNewsItem();
                        } else {
                            vm.isNewsPending = true;
                            addNewsItem();
                        }
                    },
                    function(err) {
                        $log.debug('Error status: ' + err.status);
                        flashService.error("Failed to upload image.");
                    },
                    function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        vm.progress = progressPercentage;
                        $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    })
            } else {
                // no thumbnail added
                if(vm.editing) {
                    updateNewsItem();
                } else if(vm.isNewsPending) {
                    addNewsItem();
                } else {
                    flashService.error("Failed to save News Item - a thumbnail is required.");
                }
            }
        }

        function uploadThumbnail(file) {
            var cleanedFilename = cleanFilename(vm.newsItem.title);
            var fileExtension = file.name.substr((~-file.name.lastIndexOf(".") >>> 0) + 2);
            var cleanedFilenameAndExtension = cleanedFilename + "." + fileExtension;

            return Upload.upload({
                url: AWS_S3_UPLOAD.s3url,
                method: 'POST',
                data: {
                    key: cleanedFilename + "." + fileExtension, // the key to store the file on S3, could be file name or customized
                    AWSAccessKeyId: AWS_S3_UPLOAD.AWSAccessKeyId,
                    acl: 'public-read', // sets the access to the uploaded file in the bucket: private, public-read, ...
                    policy: AWS_S3_UPLOAD.policy,
                    signature: AWS_S3_UPLOAD.signature, // base64-encoded signature based on policy string (see article below)
                    "Content-Type": file.type != '' ? file.type : 'application/octet-stream', // content type of the file (NotEmpty)
                    filename: cleanedFilenameAndExtension,
                    file: file
                },
                headers: {
                    'Authorization': undefined // we dont want to send auth: bearer JWT for s3 uploads
                }
            });
        }

        function cleanFilename(inputString){
            // get timestamp in milliseconds
            var timestamp = Date.now();
            //filename contains "~!@#$%^&*()_+=`{}[]|\:;'<>,./?Some actual text to keep, maybe...",
            var outputString = inputString.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
            var outputStringWithTimestamp = outputString+'-'+timestamp;
            $log.debug("cleanedFilename-outputStringWithTimestamp", outputStringWithTimestamp);
            return outputStringWithTimestamp;
        }

        //////////////////////
        //  ADD
        //////////////////////
        function addNewsItem() {
            newsItemService.create(vm.newsItem)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("newsItemAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("News Item Successfully Added!");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("news-item-add.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to add News Item.")
                        );
                    }

                });
        }

        //////////////////////
        //  EDIT
        //////////////////////
        function getNewsItemById() {
            newsItemService.getById($stateParams.id).then(function(response) {
                if (response) {
                    $log.debug('newsItem.edit-getById:', response);

                    vm.newsItem._id = response._id;
                    vm.newsItem.title = response.title;
                    vm.newsItem.url = response.url;
                    vm.newsItem.date = response.date;
                    vm.newsItem.thumbnailUrl = response.thumbnailUrl;
                    vm.newsItem.created = response.created;

                    var isDatePast = utcDateHelperService.isDatePast(response.releaseDate);
                    vm.newsItem.releaseDate = isDatePast ? null : response.releaseDate;

                    vm.highlight.type = 'News Item';
                    vm.highlight.title = vm.newsItem.title;
                    vm.highlight.date = vm.newsItem.date;
                    vm.highlight.url = vm.newsItem.url;
                }
            });
        }

        function updateNewsItem() {
            newsItemService.updateById(vm.newsItem)
                .then(function(response) {

                    if (!response.message) {
                        // post success
                        $log.debug("newsItem.edit.controller-success:", response);
                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("News Item Successfully Updated!");
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("newsItem.edit.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to update News Item.")
                        );
                    }
                });
        }

        function deleteNewsItem() {
            newsItemService.deleteById(vm.newsItem).then(function(response){
                if(!response.error) {
                    panelService.hide();
                    Notification.success("News Item Successfully Deleted!");
                    $timeout(function() {
                        $state.reload();
                    });
                } else {
                    Notification.error("Failed to delete News Item.");
                }
            });
        }

        function isTimeValid() {
            var releaseDate = vm.newsItem.releaseDate;
            return !releaseDate || !utcDateHelperService.isDatePast(releaseDate);
        }

        function getCurrentDate() {
            return new Date();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('admin.leadership', []);

  }
)();

(function() {
    'use strict';

    angular
        .module('admin.leadership')
        .controller('LeadershipAddEditController', LeadershipAddEditController);

    function LeadershipAddEditController($log, $scope, $state, $timeout, $rootScope, $filter, leadershipService, formsService, errorResponseService, panelService, flashService, Notification, $stateParams, Upload, AWS_S3_UPLOAD) {
        var vm = this;

        vm.leadership = {};

        vm.saveLeadership = saveLeadership;
        vm.addLeadership = addLeadership;
        vm.getLeadershipById = getLeadershipById;
        vm.updateLeadership = updateLeadership;
        vm.deleteLeadership = deleteLeadership;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  INIT
        //////////////////////
        (function(){
            vm.editing = !!$stateParams.id;
            if(vm.editing) getLeadershipById();
        })();

        //////////////////////
        //  SAVE
        //////////////////////
        function saveLeadership() {
            // saving a news item add/edit with a changed or new image
            if(!vm.leadership.imageUrl) {
                uploadThumbnail(vm.imageFile).then(
                    function(response) {
                        vm.leadership.imageUrl = response.config.url + response.config.data.filename;
                        if(vm.editing) {
                            updateLeadership();
                        } else {
                            vm.isLeadershipPending = true;
                            addLeadership();
                        }
                    },
                    function(err) {
                        $log.debug('Error status: ' + err.status);
                        flashService.error("Failed to upload image.");
                    },
                    function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        vm.progress = progressPercentage;
                        $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    })
            } else {
                // no image added
                if(vm.editing) {
                    updateLeadership();
                } else if(vm.isLeadershipPending) {
                    addLeadership();
                } else {
                    flashService.error("Failed to save Leadership - a image is required.");
                }
            }
        }

        function uploadThumbnail(file) {
            var cleanedFilename = cleanFilename(vm.leadership.name);
            var fileExtension = file.name.substr((~-file.name.lastIndexOf(".") >>> 0) + 2);
            var cleanedFilenameAndExtension = cleanedFilename + "." + fileExtension;

            return Upload.upload({
                url: AWS_S3_UPLOAD.s3url,
                method: 'POST',
                data: {
                    key: cleanedFilename + "." + fileExtension, // the key to store the file on S3, could be file name or customized
                    AWSAccessKeyId: AWS_S3_UPLOAD.AWSAccessKeyId,
                    acl: 'public-read', // sets the access to the uploaded file in the bucket: private, public-read, ...
                    policy: AWS_S3_UPLOAD.policy,
                    signature: AWS_S3_UPLOAD.signature, // base64-encoded signature based on policy string (see article below)
                    "Content-Type": file.type != '' ? file.type : 'application/octet-stream', // content type of the file (NotEmpty)
                    filename: cleanedFilenameAndExtension,
                    file: file
                },
                headers: {
                    'Authorization': undefined // we dont want to send auth: bearer JWT for s3 uploads
                }
            });
        }

        function cleanFilename(inputString){
            // get timestamp in milliseconds
            var timestamp = Date.now();
            //filename contains "~!@#$%^&*()_+=`{}[]|\:;'<>,./?Some actual text to keep, maybe...",
            var outputString = inputString.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
            var outputStringWithTimestamp = outputString+'-'+timestamp;
            $log.debug("cleanedFilename-outputStringWithTimestamp", outputStringWithTimestamp);
            return outputStringWithTimestamp;
        }

        //////////////////////
        //  ADD
        //////////////////////
        function addLeadership() {
            leadershipService.create(vm.leadership)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("leadershipAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Leadership Successfully Added!");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("news-item-add.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to add Leadership.")
                        );
                    }

                });
        }

        //////////////////////
        //  EDIT
        //////////////////////
        function getLeadershipById() {
            leadershipService.getById($stateParams.id).then(function(response) {
                if (response) {
                    $log.debug('leadership.edit-getById:', response);

                    vm.leadership._id = response._id;
                    vm.leadership.name = response.name;
                    vm.leadership.imageUrl = response.imageUrl;
                    vm.leadership.position = response.position;
                    vm.leadership.bio = response.bio;
                    vm.leadership.publications = response.publications;
                    vm.leadership.created = response.created;
                    vm.leadership.order = response.order;
                }
            });
        }

        function updateLeadership() {
            leadershipService.updateById(vm.leadership)
                .then(function(response) {

                    if (!response.message) {
                        // post success
                        $log.debug("leadership.edit.controller-success:", response);
                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Leadership Successfully Updated!");
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("leadership.edit.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to update Leadership.")
                        );
                    }
                });
        }

        function deleteLeadership() {
            leadershipService.deleteById(vm.leadership).then(function(response){
                if(!response.error) {
                    panelService.hide();
                    Notification.success("Leadership Successfully Deleted!");
                    $timeout(function() {
                        $state.reload();
                    });
                } else {
                    Notification.error("Failed to delete Leadership.");
                }
            });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('admin.event', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.event')
        .controller('EventAddEditController', EventAddEditController);

    function EventAddEditController($log, $scope, $state, $timeout, $rootScope, $filter, eventService, formsService, errorResponseService, panelService, flashService, Notification, $stateParams, Upload, AWS_S3_UPLOAD) {
        var vm = this;

        vm.event = {};

        vm.saveEvent = saveEvent;
        vm.addEvent = addEvent;
        vm.getEventById = getEventById;
        vm.updateEvent = updateEvent;
        vm.deleteEvent = deleteEvent;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  INIT
        //////////////////////
        (function(){
            vm.editing = !!$stateParams.id;
            if(vm.editing) getEventById();
        })();

        //////////////////////
        //  SAVE
        //////////////////////
        function saveEvent() {
            // saving a news item add/edit with a changed or new thumbnail
            if(!vm.event.thumbnailUrl) {
                uploadThumbnail(vm.thumbnailFile).then(
                    function(response) {
                        vm.event.thumbnailUrl = response.config.url + response.config.data.filename;
                        if(vm.editing) {
                            updateEvent();
                        } else {
                            vm.isEventPending = true;
                            addEvent();
                        }
                    },
                    function(err) {
                        $log.debug('Error status: ' + err.status);
                        flashService.error("Failed to upload image.");
                    },
                    function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        vm.progress = progressPercentage;
                        $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    })
            } else {
                // no thumbnail added
                if(vm.editing) {
                    updateEvent();
                } else if(vm.isEventPending) {
                    addEvent();
                } else {
                    flashService.error("Failed to save Event - a thumbnail is required.");
                }
            }
        }

        function uploadThumbnail(file) {
            var cleanedFilename = cleanFilename(vm.event.title);
            var fileExtension = file.name.substr((~-file.name.lastIndexOf(".") >>> 0) + 2);
            var cleanedFilenameAndExtension = cleanedFilename + "." + fileExtension;

            return Upload.upload({
                url: AWS_S3_UPLOAD.s3url,
                method: 'POST',
                data: {
                    key: cleanedFilename + "." + fileExtension, // the key to store the file on S3, could be file name or customized
                    AWSAccessKeyId: AWS_S3_UPLOAD.AWSAccessKeyId,
                    acl: 'public-read', // sets the access to the uploaded file in the bucket: private, public-read, ...
                    policy: AWS_S3_UPLOAD.policy,
                    signature: AWS_S3_UPLOAD.signature, // base64-encoded signature based on policy string (see article below)
                    "Content-Type": file.type != '' ? file.type : 'application/octet-stream', // content type of the file (NotEmpty)
                    filename: cleanedFilenameAndExtension,
                    file: file
                },
                headers: {
                    'Authorization': undefined // we dont want to send auth: bearer JWT for s3 uploads
                }
            });
        }

        function cleanFilename(inputString){
            // get timestamp in milliseconds
            var timestamp = Date.now();
            //filename contains "~!@#$%^&*()_+=`{}[]|\:;'<>,./?Some actual text to keep, maybe...",
            var outputString = inputString.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
            var outputStringWithTimestamp = outputString+'-'+timestamp;
            $log.debug("cleanedFilename-outputStringWithTimestamp", outputStringWithTimestamp);
            return outputStringWithTimestamp;
        }

        //////////////////////
        //  ADD
        //////////////////////
        function addEvent() {
            eventService.create(vm.event)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("eventAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Event Successfully Added!");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("news-item-add.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to add Event.")
                        );
                    }

                });
        }

        //////////////////////
        //  EDIT
        //////////////////////
        function getEventById() {
            eventService.getById($stateParams.id).then(function(response) {
                if (response) {
                    $log.debug('event.edit-getById:', response);

                    vm.event._id = response._id;
                    vm.event.title = response.title;
                    vm.event.url = response.url;
                    vm.event.startDate = response.startDate;
                    vm.event.endDate = response.endDate;
                    vm.event.thumbnailUrl = response.thumbnailUrl;
                    vm.event.location = response.location;
                    vm.event.created = response.created;
                }
            });
        }

        function updateEvent() {
            eventService.updateById(vm.event)
                .then(function(response) {

                    if (!response.message) {
                        // post success
                        $log.debug("event.edit.controller-success:", response);
                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Event Successfully Updated!");
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("event.edit.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to update Event.")
                        );
                    }
                });
        }

        function deleteEvent() {
            eventService.deleteById(vm.event).then(function(response){
                if(!response.error) {
                    panelService.hide();
                    Notification.success("Event Successfully Deleted!");
                    $timeout(function() {
                        $state.reload();
                    });
                } else {
                    Notification.error("Failed to delete Event.");
                }
            });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('admin.category', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.category')
        .controller('CategoryEditController', CategoryEditController);

    function CategoryEditController($log, $scope, $state, $stateParams, $timeout, $filter, $rootScope, categoryService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.category = {};
        vm.category.id = '';
        vm.category.name = '';
        vm.category.timeCreated = '';

        vm.getCategoryById = getCategoryById;
        vm.updateCategory = updateCategory;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  VIEW / EDIT
        //////////////////////

        (function init() {
            getCategoryById();
        })();

        function getCategoryById() {

            //$log.debug('category.edit-$stateParams.id:', $stateParams.id);

            // get category by id
            categoryService.getById($stateParams.id).then(function(response) {
                if (response) {
                    $log.debug('category.edit-getById:', response);

                    vm.category._id = response._id;
                    vm.category.name = response.name;
                    vm.category.timeCreated = response.timeCreated;
                }
            });
        }

        function updateCategory() {

            categoryService.updateById(vm.category)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("category.edit.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Category Successfully Updated!");

                        $timeout(function() {
                            $state.reload();
                        });


                    }
                    else {

                        // post error
                        $log.debug("category.edit.controller-error:", response);
                        flashService.error("You must enter a name.");
                    }
                });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.category')
        .controller('CategoryAddController', CategoryAddController);

    function CategoryAddController($log, $scope, $state, $timeout, $rootScope, $filter, categoryService, formsService, panelService, flashService, Notification) {
        var vm = this;
        vm.addCategory = addCategory;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  ADD
        //////////////////////
        function addCategory() {

            //vm.user.name = $filter('capitalize:true')(vm.user.name);

            categoryService.create(vm.category)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("categoryAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Category Successfully Added!");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("categoryAdd.controller-error:", response);
                        flashService.error("You must enter a name.");
                    }

                });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('admin.blogPost', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.blogPost')
        .controller('BlogPostAddEditController', BlogPostAddEditController);

    function BlogPostAddEditController($log, $scope, $state, $timeout, $rootScope, metaTagsHelperService,
            $filter, blogPostService, formsService, utcDateHelperService, errorResponseService, 
            panelService, flashService, Notification, $stateParams, Upload, AWS_S3_UPLOAD) {

        var vm = this;

        vm.blogPost = {};
        vm.categoryIds = [];

        vm.saveBlogPost = saveBlogPost;
        vm.addBlogPost = addBlogPost;
        vm.getBlogPostById = getBlogPostById;
        vm.updateBlogPost = updateBlogPost;
        vm.deleteBlogPost = deleteBlogPost;
        vm.trixAttachmentAdd = trixAttachmentAdd;
        vm.getCurrentDate = getCurrentDate;
        vm.isTimeValid = isTimeValid;
        /*
            - if we want to show & validate & use UTC on the admin side instead of local time
            - date stored in the db is always UTC
            vm.minReleaseDate = utcDateHelperService.getCurrentUtcDate();
        */

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = function() {
            return formsService.canSave.apply($scope, arguments) && isTimeValid();
        };
        //////////////////////
        //  INIT
        //////////////////////
        (function(){
            vm.editing = !!$stateParams.id;
            if(vm.editing) getBlogPostById();
        })();

        //////////////////////
        //  ATTACHMENT
        //////////////////////
        function trixAttachmentAdd(e) {
            var attachment;
            attachment = e.attachment;
            if (attachment.file) {
                return uploadAttachment(attachment);
            }
        }

        function uploadAttachment(attachment) {
            return uploadFile(attachment.file).then(
                function(response) {
                    var url, href;
                    url = href = response.config.url + response.config.data.filename;
                    return attachment.setAttributes({
                        url: url,
                        href: href
                    });
                },
                function(err) {
                    $log.debug('Error status: ' + err.status);
                    flashService.error("Failed to upload Blog attachment.");
                },
                function(evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    return attachment.setUploadProgress(progressPercentage);
                });
        }

        //////////////////////
        //  SAVE
        //////////////////////
        function saveBlogPost() {
            applyCategories();
            // saving a blog post add/edit with a changed or new pdf
            if(!vm.blogPost.headerUrl) {
                uploadFile(vm.headerFile).then(
                    function(response) {
                        vm.blogPost.headerUrl = response.config.url + response.config.data.filename;
                        if(vm.editing) {
                            updateBlogPost();
                        } else {
                            vm.isPostPending = true;
                            addBlogPost();
                        }
                    },
                    function(err) {
                        $log.debug('Error status: ' + err.status);
                        flashService.error("Failed to upload image.");
                    },
                    function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        vm.progress = progressPercentage;
                        $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    })
            } else {
                // no pdf added
                if (vm.editing) {
                    updateBlogPost();
                } else if(vm.isPostPending) {
                    addBlogPost();
                } else {
                    flashService.error("Failed to save Blog Post.");
                }
            }
        }

        function uploadFile(file) {
            var cleanedFilename = cleanFilename(vm.blogPost.title || 'blog-post-image');
            var fileExtension = file.name.substr((~-file.name.lastIndexOf(".") >>> 0) + 2);
            var cleanedFilenameAndExtension = cleanedFilename + "." + fileExtension;

            return Upload.upload({
                url: AWS_S3_UPLOAD.s3url,
                method: 'POST',
                data: {
                    key: cleanedFilename + "." + fileExtension, // the key to store the file on S3, could be file name or customized
                    AWSAccessKeyId: AWS_S3_UPLOAD.AWSAccessKeyId,
                    acl: 'public-read', // sets the access to the uploaded file in the bucket: private, public-read, ...
                    policy: AWS_S3_UPLOAD.policy,
                    signature: AWS_S3_UPLOAD.signature, // base64-encoded signature based on policy string (see article below)
                    "Content-Type": file.type != '' ? file.type : 'application/octet-stream', // content type of the file (NotEmpty)
                    filename: cleanedFilenameAndExtension,
                    file: file
                },
                headers: {
                    'Authorization': undefined // we dont want to send auth: bearer JWT for s3 uploads
                }
            });
        }

        function cleanFilename(inputString){
            // get timestamp in milliseconds
            var timestamp = Date.now();
            //filename contains "~!@#$%^&*()_+=`{}[]|\:;'<>,./?Some actual text to keep, maybe...",
            var outputString = inputString.replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'');
            var outputStringWithTimestamp = outputString+'-'+timestamp;
            $log.debug("cleanedFilename-outputStringWithTimestamp", outputStringWithTimestamp);
            return outputStringWithTimestamp;
        }

        //////////////////////
        //  ADD
        //////////////////////
        function addBlogPost() {
            blogPostService.create(vm.blogPost)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("blogPostAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Blog Post Successfully Added!");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {
                        // post error
                        $log.debug("blog-post-add.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to add Blog Post.")
                        );
                    }

                });
        }

        //////////////////////
        //  EDIT
        //////////////////////
        function getBlogPostById() {
            blogPostService.getById($stateParams.id).then(function(response) {
                if (response) {
                    $log.debug('blogPost.edit-getById:', response);

                    vm.blogPost._id = response._id;
                    vm.blogPost.title = response.title;
                    vm.blogPost.categories = response.categories;
                    vm.blogPost.author = response.author;
                    vm.blogPost.body = response.body;
                    vm.blogPost.headerUrl = response.headerUrl;
                    vm.blogPost.created = response.created;
                    
                    angular.extend(vm.blogPost, metaTagsHelperService.getMetaViewModel(response));
                    
                    var isDatePast = utcDateHelperService.isDatePast(response.releaseDate);
                    vm.blogPost.releaseDate = isDatePast ? null : response.releaseDate;

                    vm.categoryIds = [];
                    vm.blogPost.categories.forEach(function(cat){
                       vm.categoryIds.push(cat.id);
                    });
                }
            });
        }

        function updateBlogPost() {
            blogPostService.updateById(vm.blogPost)
                .then(function(response) {

                    if (!response.message) {
                        // post success
                        $log.debug("blogPost.edit.controller-success:", response);
                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Blog Post Successfully Updated!");
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {
                        // post error
                        $log.debug("blogPost.edit.controller-error:", response);
                        flashService.error(
                            errorResponseService.getErrorMessage(response, "Failed to update Blog Post.")
                        );
                    }
                });
        }

        function deleteBlogPost() {
            blogPostService.deleteById(vm.blogPost).then(function(response){
                if(!response.error) {
                    panelService.hide();
                    Notification.success("Blog Post Successfully Deleted!");
                    $timeout(function() {
                        $state.reload();
                    });
                } else {
                    Notification.error("Failed to delete Blog Post.");
                }
            });
        }

        function applyCategories() {
            vm.blogPost.categories = [];
            (vm.categoryIds || []).forEach(function(cat) {
                vm.blogPost.categories.push({ id: cat });
            });
        }

        function isTimeValid() {
            var releaseDate = vm.blogPost.releaseDate;
            return !releaseDate || !utcDateHelperService.isDatePast(releaseDate);
        }

        function getCurrentDate() {
            return new Date();
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.account', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.account')
        .controller('AccountEditController', AccountEditController);

    function AccountEditController($log, $scope, $state, $stateParams, $timeout, $filter, $rootScope, accountService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.account = {};
        vm.account.id = '';
        vm.account.first = '';
        vm.account.last = '';
        vm.account.timeCreated = '';
        vm.inviteEmail = '';
        vm.inviteSent = false;
        vm.inviteWasClicked = false;

        vm.getAccountById = getAccountById;
        vm.updateAccountDetails = updateAccountDetails;
        vm.deleteAccount = deleteAccount;
        vm.inviteClicked = inviteClicked;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  VIEW / EDIT
        //////////////////////

        (function init() {
            getAccountById();
        })();

        function getAccountById() {

            //$log.debug('account.edit-$stateParams.id:', $stateParams.id);

            // get account by id
            accountService.getById($stateParams.id).then(function(response) {

                if (response) {
                    $log.debug('account.edit-getById:', response);

                    vm.account.id = response._id;
                    vm.account.first = response.name.first;
                    vm.account.last = response.name.last;
                    vm.account.timeCreated = response.timeCreated;
                }
            });
        }

        function updateAccountDetails() {

            $log.debug('account.edit-updateAccountDetails:', vm.account);

            vm.account.first = $filter('capitalize')(vm.account.first);
            vm.account.last = $filter('capitalize')(vm.account.last);

            accountService.updateById(vm.account)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("account.edit.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Account Successfully Updated.");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });

                    }
                    else {

                        // post error
                        $log.debug("account.edit.controller-error:", response);
                        flashService.error("Failed to update account.");
                    }
                });
        }

        function deleteAccount() {
            accountService.deleteById(vm.account).then(function(response) {
                panelService.hide();
                Notification.success("Account Successfully Deleted.");

                $timeout(function() {
                    $state.reload();
                });
            });
        }

        function inviteClicked() {
            if(vm.inviteWasClicked) return;

            if(vm.inviteEmail != null && vm.inviteEmail !== "") {
                var account = {
                    id: vm.account.id,
                    email: vm.inviteEmail
                };

                vm.isFileTableLoading = true;

                accountService.invite(account).then(function(response) {
                    vm.isFileTableLoading = false;
                    if (response.error) {
                        if(response.statusCode === 409) {
                            Notification.warning(response.message);
                            vm.inviteSent = true;
                        } else {
                            Notification.error("Failed to send invitation.");
                        }
                    } else {
                        Notification.success("Invitation sent!");
                        vm.inviteSent = true;
                    }
                });
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('admin.account')
        .controller('AccountAddController', AccountAddController);

    function AccountAddController($log, $scope, $state, $timeout, $rootScope, $filter, accountService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.accounts = [];
        vm.addAccount = addAccount;
        vm.user = {};

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  ADD
        //////////////////////
        function addAccount() {

            //vm.user.name = $filter('capitalize:true')(vm.user.name);

            accountService.create(vm.user)
                .then(function(response) {

                    if (!response.message) {

                        // post success
                        $log.debug("accountAdd.controller-success:", response);

                        // close panel and go back to previous screen
                        panelService.hide();
                        Notification.success("Account Successfully Added!");

                        // push new row to table
                        //vm.accounts.push(response);
                        $timeout(function() {
                            $state.reload();
                        });
                    }
                    else {

                        // post error
                        $log.debug("accountAdd.controller-error:", response);
                        flashService.error("You must enter a name.");
                    }
 
                });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('app.services.utility', []);

})();

// Based loosely around work by Witold Szczerba - https://github.com/witoldsz/angular-http-auth

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('utcDateHelperService', utcDateHelperService);

    function utcDateHelperService() {
        var service = {};

        // service.getCurrentUtcDate = getCurrentUtcDate;
        service.isDatePast = isDatePast;

        return service;

        function getTimezoneMsOffset() {
            return new Date().getTimezoneOffset() * 60000;
        }
    
        function utcToLocalDate(date) {
            return date.getTime() - getTimezoneMsOffset();
        }

        function localDateToUtc(date) {
            return date.getTime() + getTimezoneMsOffset();
        }

        function isDatePast(date) {
            // if we want to show & validate UTC on the admin side
            // var nowDate = localDateToUtc(new Date());
            var nowDate = Date.now();
            var dateToCompare = new Date(date).getTime();
            return dateToCompare < nowDate;
        }

        function getCurrentUtcDate() {
            var nowDate = new Date();
            var month = nowDate.getUTCMonth() + 1;
            var day = nowDate.getUTCDate();
            var year = nowDate.getUTCFullYear();
            return year + '-' + month + '-' + day;
        }
    }


})();


(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('metaTagsHelperService', metaTagsHelperService);

    function metaTagsHelperService() {
        return {
            mapToModel: mapToModel,
            getMetaViewModel: getMetaViewModel,
        };

        function mapToModel(item) {
            var meta = {
                title: item.metaTitle,
                slug: validateSlug(item.metaSlug),
                description: item.metaDescription,
            };
            var itemCopy = angular.extend({}, item);
            delete itemCopy.metaTitle;
            delete itemCopy.metaSlug;
            delete itemCopy.metaDescription;
            
            return angular.extend({}, itemCopy, { meta: meta });
        }

        function getMetaViewModel(item) {
            return item.meta ? {
                metaTitle: item.meta.title,
                metaSlug: item.meta.slug,
                metaDescription: item.meta.description,
            } : {};
        }

        function validateSlug(slug) {
            if (!slug) return '';
            var lowercased = slug.trim().toLowerCase();
            return encodeURI(lowercased.replace(' ', '-'));
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('formsService', formsService);

    function formsService($log) {
        var form = {};

        function isCtrlDefined(callback) {
            return function() {
                var ctrl = arguments[0];
                if (typeof ctrl === 'undefined') {
                    return false;
                }
                return callback.apply(callback, arguments);
            }
        }

        form.hasError = isCtrlDefined(function(ngModelCtrl) {
            return ngModelCtrl.$dirty && ngModelCtrl.$invalid;
        });
        form.showError = isCtrlDefined(function(ngModelCtrl, err) {
            return ngModelCtrl.$dirty && ngModelCtrl.$error[err];
        });
        form.canSave = isCtrlDefined(function(ngFormCtrl) {
            return ngFormCtrl.$dirty && ngFormCtrl.$valid;
        });

        return form;
    }


})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('flashService', flashService);

    function flashService($log, $rootScope) {

        var service = {};

        service.success = success;
        service.error = error;
        service.info = info;
        service.warning = warning;

        initService();

        return service;

        function initService() {
            
            $rootScope.$on('$stateChangeStart', function () {
                //$log.debug("clearFlashMessage");
                clearFlashMessage();
            });

            function clearFlashMessage() {
                var flash = $rootScope.flash;
                if (flash) {
                    if (!flash.keepAfterLocationChange) {
                        delete $rootScope.flash;
                    } else {
                        // only keep for a single location change
                        flash.keepAfterLocationChange = false;
                    }
                }
            }
        }


        function success(message, keepAfterLocationChange) {

            $rootScope.isDataLoading = false;

            $rootScope.flash = {
                message: message,
                type: 'success',
                keepAfterLocationChange: keepAfterLocationChange
            };
        }

        function error(message, keepAfterLocationChange) {

            $rootScope.isDataLoading = false;

            $rootScope.flash = {
                message: message,
                type: 'danger',
                keepAfterLocationChange: keepAfterLocationChange
            };
        }

        function info(message, keepAfterLocationChange) {

            $rootScope.isDataLoading = false;

            $rootScope.flash = {
                message: message,
                type: 'info',
                keepAfterLocationChange: keepAfterLocationChange
            };
        }

        function warning(message, keepAfterLocationChange) {

            $rootScope.isDataLoading = false;

            $rootScope.flash = {
                message: message,
                type: 'warning',
                keepAfterLocationChange: keepAfterLocationChange
            };
        }
    }

})();

// This Service is used for Global Event Broadcasting
(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('errorResponseService', errorResponseService);

    function errorResponseService() {
        var service = {};

        service.getErrorMessage = getErrorMessage;

        return service;

        function parseMessage(response) {
            var extracted = /\[(.*?)\]/.exec(response.message);
            if (!extracted || !extracted[1]) {
                return response.message;
            }
            var message = extracted[1].replace(/"/g, '');
            return message.charAt(0).toUpperCase() + message.slice(1);
        }

        function prettifyFieldName(message) {
            var spacePos = message.indexOf(' ');
            if (spacePos === -1) {
                return message;
            }
            var fieldName = message.substr(0, spacePos);
            var prettyFieldName = fieldName.match(/[A-Z][a-z]+/g).join(" ");
            return prettyFieldName + message.substr(spacePos);
        }

        function getErrorMessage(response, defaultMessage) {
            if (!response.validation) {
                // unrecognized, no-validation error
                return defaultMessage;
            }
            return prettifyFieldName(parseMessage(response));
        }
    }


})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('apiHelperService', apiHelperService);

    function apiHelperService($log, $http) {

        return {
            sendHTTPRequest: sendHTTPRequest
        };

        function sendHTTPRequest(req) {

            //$log.debug("apiHelperService: sendHTTPRequest()");

            return $http(req).then(function(response) {
                // success
                //$log.debug("apiHelperService-success", response);
                return response.data;

            }, function(error) {
                // error
                $log.error("apiHelperService-error:", error.status + ": " + error.statusText);
                return error.data;
            });
        };

    }

})();

(function() {
    'use strict';

    angular
        .module('app.services.utility')
        .factory('panelService', panelService);

    function panelService($aside, $state, $stateParams, $log, $q, REDIRECT) {

        return {
            show: show,
            hide: hide
        }

        var aside = null;

        /////////////////////////
        //  SHOW PANEL (ASIDE)
        /////////////////////////
        function show(template, controller) {

            //$log.debug("panel.service: show");

            aside = $aside({
                templateUrl: template,
                controller: controller,
                controllerAs: 'vm',
                container: 'body',
                placement: 'right',
                keyboard: true,
                animation: 'am-slide-right',
                show: false,
                onHide: function() {
                    hide();
                }
            });

            return aside.$promise.then(aside.show); 
            
        }

        /////////////////////////
        //  CLOSE PANEL (ASIDE)
        /////////////////////////
        function hide() {
      
            if (aside) {
                //$log.debug("panel.service: hide");
                //aside = null;
                //aside.$promise.then(aside.destroy);
                aside.destroy();
                $state.go($state.current.parent);
            }

            
            
        }        
        
    }

})();

(function() {
    'use strict';

    angular
        .module('app.services.highlight', []);

})();


(function() {
    'use strict';

    angular
        .module('app.services.highlight')
        .factory('highlightService', highlightService);

    function highlightService($log, API, apiHelperService) {
        return {
            // GET
            getAll: getAll,
            getByIdOrIndex: getByIdOrIndex,

            // UPDATE
            updateByIndex: updateByIndex,
            updateById: updateById,

            // DELETE
            deleteById: deleteById,
            deleteByIndex: deleteByIndex,
        };

        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("highlight-data: getAll()");

            var req = {
                method: 'GET',
                url: API.HIGHLIGHTS,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getByIdOrIndex(idOrIndex) {
            var req = {
                method: 'GET',
                url: API.HIGHLIGHTS + '/' + idOrIndex
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  PUT
        //////////////////////

        function updateById(highlight) {

            $log.debug('updateById-highlight:', highlight);

            var req = {
                method: 'PUT',
                url: API.HIGHLIGHTS +'/'+ highlight._id,
                data: highlight
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function updateByIndex(highlight) {

            $log.debug('updateById-highlight:', highlight);

            var req = {
                method: 'PUT',
                url: API.HIGHLIGHTS +'/'+ highlight.index,
                data: highlight
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(highlight) {

            var req = {
                method: 'DELETE',
                url: API.HIGHLIGHTS +'/'+ highlight._id
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function deleteByIndex(highlight) {

            var req = {
                method: 'DELETE',
                url: API.HIGHLIGHTS +'/'+ highlight.index
            };
            return apiHelperService.sendHTTPRequest(req);
        }
    }

})();

/*
 ** Factory for CRUDing API.HIGHLIGHTS
 */

(function() {
    'use strict';

    angular
        .module('app.services.auth', []);

})();

// Based loosely around work by Witold Szczerba - https://github.com/witoldsz/angular-http-auth

(function() {
    'use strict';

    angular
        .module('app.services.auth')
        .factory('authService', authService);

    function authService($log, $timeout, $q, $http, $state, localStorageService, Notification, Session, API, REDIRECT, apiHelperService) {

        return {
            login: login,
            loginForgot: loginForgot,
            loginReset: loginReset,
            logout: logout,
            signup: signup,
            getSession: getSession,
            isAuthenticated: isAuthenticated,
            isAuthorized: isAuthorized,
            getInvitation: getInvitation,
            isAdmin: isAdmin,
            getRole: getRole
        };

        //////////////////////
        //  LOGIN
        //////////////////////
        function login(user, callback) {

            return $http.post(API.LOGIN, {
                    username: user.username,
                    password: user.password
                })
                .success(function(response) {

                    // login successful if there's a token in the response
                    if (response.session) {
                        // success
                        $log.debug('login.service-success:', response);

                        // create session
                        Session.create(response);
                    }
                    else {
                        // failure call back
                        $log.error('login.service-error:', response.message);
                    }
                });

        }

        //////////////////////
        //  LOGIN FORGOT
        //////////////////////
        function loginForgot(email) {

            return $http.post(API.LOGIN_FORGOT, { email: email })
                .then(function(response) {
                    $log.debug('auth.service.loginForgot-success:\n', response);
                    return response;
                })
                .catch(function(error) {
                    $log.error('auth.service.loginForgot-error:\n', error);
                    throw error;
                });
        }

        //////////////////////
        //  LOGIN RESET
        //////////////////////
        function loginReset(data) {

            return $http.post(API.LOGIN_RESET, data)
                .then(function(response) {
                    $log.debug('auth.service.loginReset-success:\n', response);
                    return response;
                })
                .catch(function(error) {
                    $log.error('auth.service.loginReset-error:\n', error);
                    throw error;
                });
        }

        //////////////////////
        //  LOGOUT
        //////////////////////
        function logout() {

            // log user out if they exist in localstorage
            if (localStorageService.get('session')) {

                //$log.debug("localStorageService.get(session)", localStorageService.get("session"));

                return $http.delete(API.LOGOUT)
                    .then(function(response) {

                        // call singleton to wipe session
                        Session.destroy();
                        // direct call to null token so user is unAuthenticated
                        // to pass route resolve on login route
                        Session.token=null;

                        // messaging
                        $log.debug('logout.service-success:', response);
                        Notification.success("You've successfully logged out.");

                        // redirect
                        $state.go(REDIRECT.LOGIN);

                    }, function(error) {
                        // failure
                        $log.error('logout.service-error:', error);

                        // call singleton to wipe session
                        Session.destroy();
                        // direct call to null token so user is unAuthenticated
                        // to pass route resolve on login route
                        Session.token=null;

                        // redirect
                        $state.go(REDIRECT.LOGIN);
                    });
            }
            else {
                $log.debug("auth.service-logout: No session exists.");
                // redirect
                $state.go(REDIRECT.LOGIN);
            }
        }

        //////////////////////
        //  SIGNUP
        //////////////////////
        function signup(data, invitationToken) {
            data.invitationToken = invitationToken;

            return $http.post(API.SIGNUP, data)
                .success(function(response) {

                    if (response.session) {
                        // success
                        //$log.debug('signup.service-success:', response);

                        // create session
                        Session.create(response);

                        // go to main page
                        $state.go(REDIRECT.ADMIN);

                    }
                    else {
                        // failure call back
                        $log.error('signup.service-error:', response.message);
                    }
                });

        }

        function getInvitation(token) {
            var req = {
                method: 'GET',
                url: API.SIGNUP_INVITATION + '/' + token,
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        var deferredCurrentUser;

        /////////////////////////////
        //  GET EXISTING SESSION
        /////////////////////////////
        function getSession() {

            //$log.debug("auth.service: getSession-check for session");
            //$log.debug('localStorageService.get(session):', localStorageService.get('session'));

            // get user from localstorage
            if (localStorageService.get('session')) {

                $log.debug("auth.service: getSession-session exists");

                // update session with local storage
                Session.update();
                //$log.debug("auth.service: getSession-updated session");
            }
            else {
                $log.debug("auth.service: getSession-NO session exists");
                // go to main page
                //$state.go(REDIRECT.LOGIN);
            }
        }

        //////////////////////
        //  isAUTHENTICATED
        //////////////////////
        function isAuthenticated() {
            //$log.debug("auth.service-isAuthenticated-Session.token:", Session.token);
            return !!Session.token;
        }

        function isAdmin() {
            return isAuthorized('admin');
        }

        //////////////////////
        //  isAUTHORIZED
        //////////////////////

        // pass role name to check against allowed from backend
        function isAuthorized(authorizedRoles) {
            if (!angular.isArray(authorizedRoles)) {
                // converts if no brackets around role name in the route
                authorizedRoles = [authorizedRoles];
            }

            // if user is authed with session, convert roles object to array to be searched
            var userRoles = Session.userRole ? Object.keys(Session.userRole) : '';  // ES6 - works only in modern browsers

            // compare the two role sets to see if we allow access to the route
            var foundRole = authorizedRoles.some(function(roles) { return userRoles.indexOf(roles) != -1; });

            //$log.debug("isAuthorized-Session.userRole:", Session.userRole);
            //$log.debug("isAuthorized-isAuthenticated:", isAuthenticated());
            //$log.debug("isAuthorized-authorizedRoles:", authorizedRoles);
            //$log.debug("isAuthorized-userRoles:", userRoles);
            //$log.debug("isAuthorized-foundRole?", foundRole);

            return (isAuthenticated() && foundRole);
        }

        function getRole(roleName) {
            return Session.userRole[roleName];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.auth')
        .factory('Session', Session);

    function Session($log, $http, localStorageService) {

        var session = {
            create: create,
            update: update,
            destroy: destroy,
        }
        
        function create(obj) {     


            // add jwt token to auth header for all requests made by the $http service
            $http.defaults.headers.common.Authorization = 'Bearer ' + obj.id_token;

            // FUTURE: determine jwt expire time
            // var hoursToExpireTokenIn = 4;
            // var tokenExpiry = new Date(obj.time);
            // tokenExpiry.setHours(tokenExpiry.getHours() + hoursToExpireTokenIn);

            // save vars to keep user logged in between page refreshes
            localStorageService.set('session', {
                id:         obj.session._id,
                expiresAt:  obj.session.time,
                key:        obj.session.key,
                userId:     obj.session.userId,
                userEmail:  obj.user.email,
                userName:   obj.user.username,
                userRole:   obj.user.roles,
                token:      obj.id_token
            });

            // set vars for session
            session.id =            obj.session._id;
            session.expiresAt =     obj.session.time;
            session.key =           obj.session.key;
            session.userId =        obj.session.userId;
            session.userEmail =     obj.user.email;
            session.userName =      obj.user.username;
            session.userRole =      obj.user.roles;
            session.token =         obj.id_token;

            //$log.debug("Session.$http.defaults.headers.common.Authorization:", $http.defaults.headers.common.Authorization);    
            //$log.debug("Session.session:", session);

        };

        function update() {            
            // add jwt token to auth header for all requests made by the $http service
            $http.defaults.headers.common.Authorization = 'Bearer ' + localStorageService.get('session').token;
            //$log.debug('auth-session-token:', token);

            // set vars for session on page refresh
            session.id =            localStorageService.get('session').id;
            session.expiresAt =     localStorageService.get('session').expiresAt;
            session.key =           localStorageService.get('session').key;
            session.userId =        localStorageService.get('session').userId;
            session.userEmail =     localStorageService.get('session').userEmail;
            session.userName =      localStorageService.get('session').userName;
            session.userRole =      localStorageService.get('session').userRole;
            session.token =         localStorageService.get('session').token;

        }

        function destroy() {

            $log.debug('Session.destroy: clearing localstorage');
            // remove jwt token from header
            $http.defaults.headers.common.Authorization='';
            // remove user from local storage and clear http auth header
            localStorageService.remove('session');
            // unset session vars
            var session={};
        };

        return session;

    }
})();

(function() {
    'use strict';

    angular
        .module('app.services.auth')
        .factory('authSecurityService', authSecurityService);

    function authSecurityService($log, $timeout, $state, $q, $rootScope, authService, loginModalService, Notification, REDIRECT) {

        return {
            requireAdminUser: requireAdminUser,
            requireAuthenticatedUser: requireAuthenticatedUser,
            requireUnauthenticatedUser: requireUnauthenticatedUser
            //requireVerifiedUser: requireVerifiedUser,
            //requireUnverifiedUser: requireUnverifiedUser
        }

        var redirect;


        /////////////////////////////
        //  SECURITY: ADMIN
        /////////////////////////////
        function requireAdminUser() {
            //$log.debug("auth.security: requireAdminUser");

            var defer = $q.defer();
            var authorizedRoles = ['admin', 'account'];

            // check if user has admin role
            if (authService.isAuthorized(authorizedRoles)) {

                // user is authenticated and has the correct role - let them pass
                $log.debug("auth.security: requireAdminUser: user has admin role-resolve");
                // $timeout(function() {
                //     $state.go(REDIRECT.ADMIN);
                // });

                defer.resolve();
            }
            else if (authService.isAuthenticated()) {
                // user is authenticated and does not have the admin role - redirect home
                $log.debug("auth.security: requireAdminUser: user DOES NOT HAVE admin role-reject");
                Notification.warning({message: "You don't have permission to access this area.", title: "Not Authorized"});

                // must be wrapped with timeout for async or will hang
                $timeout(function() {
                    authService.logout();
                    $state.go(REDIRECT.LOGIN);
                });
                defer.reject();
            }
            else {
                $log.debug("auth.security: requireAdminUser: user is NOT AUTHED and DOES NOT HAVE admin role-reject");
                // user is not authenticated (therefore doesnt have a role)

                // must be wrapped with timeout for async or will hang
                $timeout(function() {
                    $log.debug("auth.security: ATTEMPTING REDIRECT TO LOGIN");

                    $state.go(REDIRECT.LOGIN);
                });

                //loginModalService.show();
                defer.reject();
            }

            return defer.promise;
        }

        //////////////////////////////////
        //  SECURITY: AUTHENTICATED
        //////////////////////////////////
        function requireAuthenticatedUser() {
            //$log.debug("auth.security: requireAuthenticatedUser");

            var defer = $q.defer();

            // check if user is authenticated
            if (authService.isAuthenticated()) {

                // user is authenticated and does not have the admin role - redirect home
                $log.debug("auth.security: requireAuthenticatedUser: user is authenitcated-resolve");
                defer.resolve();
            }
            else {
                $log.debug("auth.security: requireAuthenticatedUser: user not authenitcated-pop modal");
                loginModalService.show();
                defer.reject();
            }
            return defer.promise;
        }

        //////////////////////////////////
        //  SECURITY: UNAUTHENTICATED
        //////////////////////////////////
        function requireUnauthenticatedUser() {
            //$log.debug("auth.security: requireUnauthenticatedUser");

            var defer = $q.defer();

            if (authService.isAuthenticated()) {
                // user is authenticated - dont let them access the requested page - redirect
                $log.debug("auth.security: requireUnauthenticatedUser-redirect");
                Notification.warning({message: "You're Authenticated.", title: "Access Denied"});

                // must be wrapped with timeout for async or will hang
                $timeout(function() {
                    $state.go(REDIRECT.ADMIN);
                });
                defer.reject();
            }
            else {
                $log.debug("auth.security: requireUnauthenticatedUser-resolve", $state);

                defer.resolve();
            }
            return defer.promise;
        }


        /** FUTURE FOR EMAIL / SIGNUP VERIFICATION

        /////////////////////////////
        //  SECURITY: VERIFIED
        /////////////////////////////
        function requireVerifiedUser() {
            $log.debug("auth.security: requireVerifiedUser");
            return {
                resolve: function() {
                    var deferred = $q.defer();
                    var unwatch = $rootScope.$watch('currentUser', function(currentUser) {
                        if (angular.isDefined(currentUser)) {
                            if (currentUser) {
                                deferred.resolve(currentUser);
                            }
                            else {
                                deferred.reject();
                                $state.go('user-login');
                            }
                            unwatch();
                        }
                    });
                    return deferred.promise;
                }
            }
        }

        /////////////////////////////
        //  SECURITY: UNVERIFIED
        /////////////////////////////
        function requireUnverifiedUser() {
            $log.debug("auth.security: requireUnverifiedUser");
            return {
                resolve: function() {
                    var deferred = $q.defer();
                    var unwatch = $rootScope.$watch('currentUser', function(currentUser) {
                        if (angular.isDefined(currentUser)) {
                            if (currentUser) {
                                deferred.resolve(currentUser);
                            }
                            else {
                                deferred.reject();
                                $state.go('user-login');
                            }
                            unwatch();
                        }
                    });
                    return deferred.promise;
                }
            }
        }
        **/

    }



})();

// This service provides guard methods to support AngularJS routes.
// You can add them as resolves to routes to require authorization levels before allowing a route change to complete

(function() {
    'use strict';

    angular
        .module('app.services.auth')
        .factory('authInterceptorService', authInterceptorService);

    function authInterceptorService($rootScope, $q, $log, $injector) {

        return {
            responseError: responseError
        };

        function responseError(response) {
            
            // 401 UNAUTHORIZED CAUGHT - No Valid Auth Credentials OR Session expired
            if (response.status === 401) {
                $log.debug("authInterceptor.service: 401: response:", response);

                // Open modal for 401s
                // var loginModalService = $injector.get('loginModalService');
                // loginModalService.show();

                // We now redirect to login page for 401s
                var stateService = $injector.get('$state');
                var authService = $injector.get('authService');
                
                authService.logout();
                stateService.go(REDIRECT.LOGIN);
            }

            /* If not a 401, do nothing with this error.
             * This is necessary to make a `responseError`
             * interceptor a no-op. */
            return $q.reject(response);
        }
    };

})();

// This http interceptor listens for 401 authentication failures
// Based loosely around work by Witold Szczerba - https://github.com/witoldsz/angular-http-auth

(function() {
    'use strict';

    angular
        .module('admin.user')
        .factory('userService', userService);

    function userService($log, API, apiHelperService) {

        var users = {};

        return {

            // GET
            getAll: getAll,
            getAllNotPaged: getAllNotPaged,
            getMy: getMy,
            getById: getById,
            getByUsername: getByUsername,
            searchByUsername: searchByUsername,

            // CREATE
            create: create,
            createNotesById: createNotesById,
            createStatusById: createStatusById,

            // UPDATE
            updateMy: updateMy,
            updateMyPassword: updateMyPassword,
            updateById: updateById,
            updateUsernameLinkById: updateUsernameLinkById,

            // DELETE
            deleteById: deleteById,
            deleteUsernameLinkById: deleteUsernameLinkById,

            // CACHE
            updateCache: updateCache,
            getCachedById: getCachedById
        };



        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("user-data: getAll()");

            var req = {
                method: 'GET',
                url: API.USERS,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getAllNotPaged() {

            $log.debug("user-data: getAllNotPaged()");

            var req = {
                method: 'GET',
                url: API.USERS + '/all'
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getMy() {

            var req = {
                method: 'GET',
                url: API.USERS +'/my',
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        function getById(id) {

            var req = {
                method: 'GET',
                url: API.USERS + '/'+id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        function getByUsername(username) {

            var req = {
                method: 'GET',
                url: API.USERS + '/'+username +'/profile',
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        function searchByUsername(username) {

            var req = {
                method: 'GET',
                url: API.USERS + '/'+username +'/search',
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(user) {

            var req = {
                method: 'POST',
                url: API.USERS,
                data: user
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function createNotesById(user) {

            var req = {
                method: 'POST',
                url: API.USERS +'/'+ user.id +'/notes',
                data: user.notes
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function createStatusById(user) {

            var req = {
                method: 'POST',
                url: API.USERS +'/'+ user.id +'/status',
                data: user.status
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////
        function updateMy(user) {

            var req = {
                method: 'PUT',
                url: API.USERS +'/my',
                data: {
                    username: user.username,
                    email: user.email
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function updateMyPassword(password) {

            var req = {
                method: 'PUT',
                url: API.USERS +'/my/password',
                data: {
                    password: password
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function updateById(user) {

            $log.debug('updateById-user:', user);

            var req = {
                method: 'PUT',
                url: API.USERS +'/'+ user.id,
                data: {
                    name: {
                        first: user.first,
                        last: user.last
                    }
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function updateUsernameLinkById(user) {

            var req = {
                method: 'PUT',
                url: API.USERS +'/'+ user.id +'/user',
                data: user.username
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(user) {

            var req = {
                method: 'DELETE',
                url: API.USERS +'/'+ user.id
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function deleteUsernameLinkById(user) {

            var req = {
                method: 'DELETE',
                url: API.USERS +'/'+ user.id +'/user'
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  CACHE
        //////////////////////
        function updateCache(limit, page, sort) {
            var req = {
                method: 'GET',
                url: API.USERS,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req).then(function(result) {

                result.data.forEach(function(u) {
                    users[u._id] = u;
                });
                return result;
            });
        }

        function getCachedById(id) {
            return users[id];
        }
    }

})();

/*
 ** Factory for CRUDing API.USERS
 */

(function() {
    'use strict';

    angular
        .module('admin.teamMember')
        .factory('teamMemberService', teamMemberService);

    function teamMemberService($log, API, apiHelperService) {
        return {
            // GET
            getAll: getAll,
            getById: getById,

            // CREATE
            create: create,

            // UPDATE
            updateById: updateById,

            // DELETE
            deleteById: deleteById,
        };

        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("teamMember-data: getAll()");

            var req = {
                method: 'GET',
                url: API.TEAM,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getById(id) {
            var req = {
                method: 'GET',
                url: API.TEAM + '/' + id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(teamMember) {

            var req = {
                method: 'POST',
                url: API.TEAM,
                data: teamMember
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////

        function updateById(teamMember) {

            $log.debug('updateById-teamMember:', teamMember);

            var req = {
                method: 'PUT',
                url: API.TEAM +'/'+ teamMember._id,
                data: teamMember
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(teamMember) {

            var req = {
                method: 'DELETE',
                url: API.TEAM +'/'+ teamMember._id
            };
            return apiHelperService.sendHTTPRequest(req);
        }
    }

})();

/*
 ** Factory for CRUDing API.TEAM
 */

(function() {
    'use strict';

    angular
        .module('admin.teamMember')
        .config(eventRouteConfig);

    function eventRouteConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  NEWS
        //////////////////////
        .state('admin.teamMember', {
            parent: 'admin',
            url: "/team",
            templateUrl: "app/admin/sections/team-member/team-member.view.html",
            controller: 'TeamMemberController',
            controllerAs: 'vm',
            ncyBreadcrumb: {
                label: 'Team Member'
            }
        })

        //////////////////////
        //  PANELS
        //////////////////////

        .state('teamMember-add', {
            parent: 'admin.teamMember',
            url: '/add',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/team-member/team-member-add-edit/team-member-add-edit.view.html',
                    'TeamMemberAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('teamMember-edit', {
            parent: 'admin.teamMember',
            url: '/:id',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/team-member/team-member-add-edit/team-member-add-edit.view.html',
                    'TeamMemberAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            },
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.teamMember')
        .controller('TeamMemberController', TeamMemberController);

    function TeamMemberController($log, $scope, $state, $timeout, $rootScope, teamMemberService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.teamMembers = [];
        vm.getTeamMembers = getTeamMembers;
        vm.user = {};

        vm.itemsByPage = 10;
        var limit='';
        var page='';

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  GET
        //////////////////////
        function getTeamMembers(tableState) {

            vm.isTableLoading = true;

            var pagination = tableState.pagination;
            var selectedPage = pagination.start+1;
            //var sort = tableState.sort.predicate;
            var sort = '-startDate';  // sort newest first
            //$log.debug('tableState', tableState);
            //$log.debug('PAGINATION', pagination);

            //var sort = "";
            limit = vm.itemsByPage;            // Number of entries showed per page.
            page = selectedPage || 1;         // Current Page

            // get all teamMembers
            teamMemberService.getAll(limit, page, sort).then(function(response) {
                if (response.data) {
                    //$log.debug('RESPONSE', response);

                    vm.teamMembers = response.data;
                    limit = response.items.limit;
                    page = response.pages.total;
                    tableState.pagination.numberOfPages = response.pages.total;

                    vm.isTableLoading = false;
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.statuses', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.pressRelease')
        .factory('pressReleaseService', pressReleaseService);

    function pressReleaseService($log, API, apiHelperService, metaTagsHelperService) {
        return {
            // GET
            getAll: getAll,
            getById: getById,

            // CREATE
            create: create,

            // UPDATE
            updateById: updateById,

            // DELETE
            deleteById: deleteById,
        };

        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("pressRelease-data: getAll()");

            var req = {
                method: 'GET',
                url: API.PRESS,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getById(id) {
            var req = {
                method: 'GET',
                url: API.PRESS + '/' + id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(pressRelease) {
            var press = metaTagsHelperService.mapToModel(pressRelease);
            var req = {
                method: 'POST',
                url: API.PRESS,
                data: press
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////

        function updateById(pressRelease) {

            $log.debug('updateById-pressRelease:', pressRelease);
            var press = metaTagsHelperService.mapToModel(pressRelease);
            var req = {
                method: 'PUT',
                url: API.PRESS +'/'+ pressRelease._id,
                data: {
                    title: pressRelease.title,
                    body: pressRelease.body,
                    date: pressRelease.date,
                    contactInfo: pressRelease.contactInfo,
                    pdfUrl: pressRelease.pdfUrl,
                    releaseDate: pressRelease.releaseDate,
                    meta: press.meta,
                    //signatureUrl: pressRelease.signatureUrl,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(pressRelease) {

            var req = {
                method: 'DELETE',
                url: API.PRESS +'/'+ pressRelease._id
            };
            return apiHelperService.sendHTTPRequest(req);
        }
    }

})();

/*
 ** Factory for CRUDing API.PRESS
 */

(function() {
    'use strict';

    angular
        .module('admin.pressRelease')
        .config(pressReleaseRouteConfig);

    function pressReleaseRouteConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  NEWS
        //////////////////////
        .state('admin.pressRelease', {
            parent: 'admin',
            url: "/press",
            templateUrl: "app/admin/sections/press-release/press-release.view.html",
            controller: 'PressReleaseController',
            controllerAs: 'vm',
            ncyBreadcrumb: {
                label: 'Press Releases'
            }
        })

        //////////////////////
        //  PANELS
        //////////////////////

        .state('pressRelease-add', {
            parent: 'admin.pressRelease',
            url: '/add',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/press-release/press-release-add-edit/press-release-add-edit.view.html',
                    'PressReleaseAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('pressRelease-edit', {
            parent: 'admin.pressRelease',
            url: '/:id',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/press-release/press-release-add-edit/press-release-add-edit.view.html',
                    'PressReleaseAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            },
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.pressRelease')
        .controller('PressReleaseController', PressReleaseController);

    function PressReleaseController($log, $scope, $state, $timeout, $rootScope, pressReleaseService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.pressReleases = [];
        vm.getPressReleases = getPressReleases;
        vm.user = {};

        vm.itemsByPage = 10;
        var limit='';
        var page='';

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  GET
        //////////////////////
        function getPressReleases(tableState) {

            vm.isTableLoading = true;

            var pagination = tableState.pagination;
            var selectedPage = pagination.start+1;
            //var sort = tableState.sort.predicate;
            var sort = '-date';  // sort newest first
            //$log.debug('tableState', tableState);
            //$log.debug('PAGINATION', pagination);

            //var sort = "";
            limit = vm.itemsByPage;            // Number of entries showed per page.
            page = selectedPage || 1;         // Current Page

            // get all pressReleases
            pressReleaseService.getAll(limit, page, sort).then(function(response) {

                if (response.data) {
                    //$log.debug('RESPONSE', response);

                    vm.pressReleases = response.data;
                    limit = response.items.limit;
                    page = response.pages.total;
                    tableState.pagination.numberOfPages = response.pages.total;

                    vm.isTableLoading = false;
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.newsItem')
        .factory('newsItemService', newsItemService);

    function newsItemService($log, API, apiHelperService) {
        return {
            // GET
            getAll: getAll,
            getById: getById,

            // CREATE
            create: create,

            // UPDATE
            updateById: updateById,

            // DELETE
            deleteById: deleteById,
        };

        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("newsItem-data: getAll()");

            var req = {
                method: 'GET',
                url: API.NEWS,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getById(id) {
            var req = {
                method: 'GET',
                url: API.NEWS + '/' + id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(newsItem) {

            var req = {
                method: 'POST',
                url: API.NEWS,
                data: newsItem
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////

        function updateById(newsItem) {

            $log.debug('updateById-newsItem:', newsItem);

            var req = {
                method: 'PUT',
                url: API.NEWS +'/'+ newsItem._id,
                data: {
                    title: newsItem.title,
                    url: newsItem.url,
                    date: newsItem.date,
                    thumbnailUrl: newsItem.thumbnailUrl,
                    releaseDate: newsItem.releaseDate,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(newsItem) {

            var req = {
                method: 'DELETE',
                url: API.NEWS +'/'+ newsItem._id
            };
            return apiHelperService.sendHTTPRequest(req);
        }
    }

})();

/*
 ** Factory for CRUDing API.NEWS
 */

(function() {
    'use strict';

    angular
        .module('admin.newsItem')
        .config(newsItemRouteConfig);

    function newsItemRouteConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  NEWS
        //////////////////////
        .state('admin.newsItem', {
            parent: 'admin',
            url: "/news",
            templateUrl: "app/admin/sections/news-item/news-item.view.html",
            controller: 'NewsItemController',
            controllerAs: 'vm',
            ncyBreadcrumb: {
                label: 'News Items'
            }
        })

        //////////////////////
        //  PANELS
        //////////////////////

        .state('newsItem-add', {
            parent: 'admin.newsItem',
            url: '/add',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/news-item/news-item-add-edit/news-item-add-edit.view.html',
                    'NewsItemAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('newsItem-edit', {
            parent: 'admin.newsItem',
            url: '/:id',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/news-item/news-item-add-edit/news-item-add-edit.view.html',
                    'NewsItemAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            },
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.newsItem')
        .controller('NewsItemController', NewsItemController);

    function NewsItemController($log, $scope, $state, $timeout, $rootScope, newsItemService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.newsItems = [];
        vm.getNewsItems = getNewsItems;
        vm.user = {};

        vm.itemsByPage = 10;
        var limit='';
        var page='';

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  GET
        //////////////////////
        function getNewsItems(tableState) {

            vm.isTableLoading = true;

            var pagination = tableState.pagination;
            var selectedPage = pagination.start+1;
            //var sort = tableState.sort.predicate;
            var sort = '-date';  // sort newest first
            //$log.debug('tableState', tableState);
            //$log.debug('PAGINATION', pagination);

            //var sort = "";
            limit = vm.itemsByPage;            // Number of entries showed per page.
            page = selectedPage || 1;         // Current Page

            // get all newsItems
            newsItemService.getAll(limit, page, sort).then(function(response) {

                if (response.data) {
                    //$log.debug('RESPONSE', response);

                    vm.newsItems = response.data;
                    limit = response.items.limit;
                    page = response.pages.total;
                    tableState.pagination.numberOfPages = response.pages.total;

                    vm.isTableLoading = false;
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.leadership')
        .factory('leadershipService', leadershipService);

    function leadershipService($log, API, apiHelperService) {
        return {
            // GET
            getAll: getAll,
            getById: getById,

            // CREATE
            create: create,

            // UPDATE
            updateById: updateById,

            // DELETE
            deleteById: deleteById,
        };

        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("leadership-data: getAll()");

            var req = {
                method: 'GET',
                url: API.LEADERSHIP,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getById(id) {
            var req = {
                method: 'GET',
                url: API.LEADERSHIP + '/' + id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(leadership) {

            var req = {
                method: 'POST',
                url: API.LEADERSHIP,
                data: leadership
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////

        function updateById(leadership) {

            $log.debug('updateById-leadership:', leadership);

            var req = {
                method: 'PUT',
                url: API.LEADERSHIP +'/'+ leadership._id,
                data: leadership
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(leadership) {

            var req = {
                method: 'DELETE',
                url: API.LEADERSHIP +'/'+ leadership._id
            };
            return apiHelperService.sendHTTPRequest(req);
        }
    }

})();

/*
 ** Factory for CRUDing API.LEADERSHIP
 */

(function() {
    'use strict';

    angular
        .module('admin.leadership')
        .config(eventRouteConfig);

    function eventRouteConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  NEWS
        //////////////////////
            .state('admin.leadership', {
            parent: 'admin',
            url: "/leadership",
            templateUrl: "app/admin/sections/leadership/leadership.view.html",
            controller: 'LeadershipController',
            controllerAs: 'vm',
            ncyBreadcrumb: {
                label: 'Leadership'
            }
        })

        //////////////////////
        //  PANELS
        //////////////////////

        .state('leadership-add', {
            parent: 'admin.leadership',
            url: '/add',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/leadership/leadership-add-edit/leadership-add-edit.view.html',
                    'LeadershipAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('leadership-edit', {
            parent: 'admin.leadership',
            url: '/:id',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/leadership/leadership-add-edit/leadership-add-edit.view.html',
                    'LeadershipAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            },
        })
    }

})();
(function() {
    'use strict';

    angular
        .module('admin.leadership')
        .controller('LeadershipController', LeadershipController);

    function LeadershipController($log, $scope, $state, $timeout, $rootScope, leadershipService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.leaderships = [];
        vm.getLeaderships = getLeaderships;
        vm.user = {};

        vm.itemsByPage = 10;
        var limit='';
        var page='';

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  GET
        //////////////////////
        function getLeaderships(tableState) {
            vm.isTableLoading = true;

            var pagination = tableState.pagination;
            var selectedPage = pagination.start+1;
            //var sort = tableState.sort.predicate;
            var sort = '-startDate';  // sort newest first
            //$log.debug('tableState', tableState);
            //$log.debug('PAGINATION', pagination);

            //var sort = "";
            limit = vm.itemsByPage;            // Number of entries showed per page.
            page = selectedPage || 1;         // Current Page

            // get all leaderships
            leadershipService.getAll(limit, page, sort).then(function(response) {
                $log.debug(response);
                if (response.data) {
                    //$log.debug('RESPONSE', response);

                    vm.leaderships = response.data;
                    limit = response.items.limit;
                    page = response.pages.total;
                    tableState.pagination.numberOfPages = response.pages.total;

                    vm.isTableLoading = false;
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.event')
        .factory('eventService', eventService);

    function eventService($log, API, apiHelperService) {
        return {
            // GET
            getAll: getAll,
            getById: getById,

            // CREATE
            create: create,

            // UPDATE
            updateById: updateById,

            // DELETE
            deleteById: deleteById,
        };

        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("event-data: getAll()");

            var req = {
                method: 'GET',
                url: API.EVENTS,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getById(id) {
            var req = {
                method: 'GET',
                url: API.EVENTS + '/' + id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(ev) {
            var event = eventDateToUtc(ev);
            var req = {
                method: 'POST',
                url: API.EVENTS,
                data: event
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////

        function updateById(ev) {    
            var event = eventDateToUtc(ev);
            $log.debug('updateById-event:', event);

            var req = {
                method: 'PUT',
                url: API.EVENTS +'/'+ event._id,
                data: {
                    title: event.title,
                    url: event.url,
                    startDate: event.startDate,
                    endDate: event.endDate,
                    thumbnailUrl: event.thumbnailUrl,
                    location: event.location,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(event) {

            var req = {
                method: 'DELETE',
                url: API.EVENTS +'/'+ event._id
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function eventDateToUtc(event) {
            var ev = angular.extend({}, event);
            ev.startDate = moment.utc(ev.startDate).toDate();
            ev.endDate = moment.utc(ev.endDate).toDate();
            return ev;
        }
    }

})();

/*
 ** Factory for CRUDing API.EVENTS
 */

(function() {
    'use strict';

    angular
        .module('admin.event')
        .config(eventRouteConfig);

    function eventRouteConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  NEWS
        //////////////////////
        .state('admin.event', {
            parent: 'admin',
            url: "/events",
            templateUrl: "app/admin/sections/event/event.view.html",
            controller: 'EventController',
            controllerAs: 'vm',
            ncyBreadcrumb: {
                label: 'Events'
            }
        })

        //////////////////////
        //  PANELS
        //////////////////////

        .state('event-add', {
            parent: 'admin.event',
            url: '/add',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/event/event-add-edit/event-add-edit.view.html',
                    'EventAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('event-edit', {
            parent: 'admin.event',
            url: '/:id',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/event/event-add-edit/event-add-edit.view.html',
                    'EventAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            },
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.event')
        .controller('EventController', EventController);

    function EventController($log, $scope, $state, $timeout, $rootScope, eventService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.events = [];
        vm.getEvents = getEvents;
        vm.user = {};

        vm.itemsByPage = 10;
        var limit='';
        var page='';

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  GET
        //////////////////////
        function getEvents(tableState) {

            vm.isTableLoading = true;

            var pagination = tableState.pagination;
            var selectedPage = pagination.start+1;
            //var sort = tableState.sort.predicate;
            var sort = '-startDate';  // sort newest first
            //$log.debug('tableState', tableState);
            //$log.debug('PAGINATION', pagination);

            //var sort = "";
            limit = vm.itemsByPage;            // Number of entries showed per page.
            page = selectedPage || 1;         // Current Page

            // get all events
            eventService.getAll(limit, page, sort).then(function(response) {
                if (response.data) {
                    //$log.debug('RESPONSE', response);

                    vm.events = response.data;
                    limit = response.items.limit;
                    page = response.pages.total;
                    tableState.pagination.numberOfPages = response.pages.total;

                    vm.isTableLoading = false;
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.category')
        .factory('categoryService', categoryService);

    function categoryService($log, API, apiHelperService) {
        return {
            // GET
            getAll: getAll,
            getById: getById,

            // CREATE
            create: create,

            // UPDATE
            updateById: updateById,

            // DELETE
            deleteById: deleteById,
        };

        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("category-data: getAll()");

            var req = {
                method: 'GET',
                url: API.CATEGORIES,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getById(id) {
            var req = {
                method: 'GET',
                url: API.CATEGORIES + '/' + id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(category) {

            var req = {
                method: 'POST',
                url: API.CATEGORIES,
                data: category
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////

        function updateById(category) {

            $log.debug('updateById-category:', category);

            var req = {
                method: 'PUT',
                url: API.CATEGORIES +'/'+ category._id,
                data: {
                    name: category.name
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(category) {

            var req = {
                method: 'DELETE',
                url: API.CATEGORIES +'/'+ category._id
            };
            return apiHelperService.sendHTTPRequest(req);
        }
    }

})();

/*
 ** Factory for CRUDing API.CATEGORIES
 */

(function() {
    'use strict';

    angular
        .module('admin.category')
        .config(categoryRouteConfig);

    function categoryRouteConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  ACCOUNTS
        //////////////////////
        .state('admin.category', {
            parent: 'admin',
            url: "/categories",
            templateUrl: "app/admin/sections/category/category.view.html",
            controller: 'CategoryController',
            controllerAs: 'vm',
            ncyBreadcrumb: {
                label: 'Categories'
            }
        })

        //////////////////////
        //  PANELS
        //////////////////////

        .state('category-add', {
            parent: 'admin.category',
            url: '/add',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/category/category-add/category-add.view.html',
                    'CategoryAddController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('category-edit', {
            parent: 'admin.category',
            url: '/:id',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/category/category-edit/category-edit.view.html',
                    'CategoryEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            },
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.category')
        .controller('CategoryController', CategoryController);

    function CategoryController($log, $scope, $state, $timeout, $rootScope, categoryService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.categories = [];
        vm.getCategories = getCategories;
        vm.user = {};

        vm.itemsByPage = 10;
        var limit='';
        var page='';

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  GET
        //////////////////////
        function getCategories(tableState) {

            vm.isTableLoading = true;

            var pagination = tableState.pagination;
            var selectedPage = pagination.start+1;
            //var sort = tableState.sort.predicate;
            var sort = '-timeCreated';  // sort newest first
            //$log.debug('tableState', tableState);
            //$log.debug('PAGINATION', pagination);

            //var sort = "";
            limit = vm.itemsByPage;            // Number of entries showed per page.
            page = selectedPage || 1;         // Current Page

            // get all categories
            categoryService.getAll(limit, page, sort).then(function(response) {

                if (response.data) {
                    //$log.debug('RESPONSE', response);

                    vm.categories = response.data;
                    limit = response.items.limit;
                    page = response.pages.total;
                    tableState.pagination.numberOfPages = response.pages.total;

                    vm.isTableLoading = false;
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.blogPost')
        .factory('blogPostService', blogPostService);

    function blogPostService($log, API, apiHelperService, metaTagsHelperService) {
        return {
            // GET
            getAll: getAll,
            getById: getById,

            // CREATE
            create: create,

            // UPDATE
            updateById: updateById,

            // DELETE
            deleteById: deleteById,
        };

        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("blogPost-data: getAll()");

            var req = {
                method: 'GET',
                url: API.BLOG,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getById(id) {
            var req = {
                method: 'GET',
                url: API.BLOG + '/' + id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(blogPost) {
            var post = metaTagsHelperService.mapToModel(blogPost);
            var req = {
                method: 'POST',
                url: API.BLOG,
                data: post
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////

        function updateById(blogPost) {

            $log.debug('updateById-blogPost:', blogPost);

            var post = metaTagsHelperService.mapToModel(blogPost);
            var req = {
                method: 'PUT',
                url: API.BLOG +'/'+ blogPost._id,
                data: post
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(blogPost) {

            var req = {
                method: 'DELETE',
                url: API.BLOG +'/'+ blogPost._id
            };
            return apiHelperService.sendHTTPRequest(req);
        }
    }

})();

/*
 ** Factory for CRUDing API.BLOG
 */

(function() {
    'use strict';

    angular
        .module('admin.blogPost')
        .config(blogPostRouteConfig);

    function blogPostRouteConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  BLOG
        //////////////////////
        .state('admin.blogPost', {
            parent: 'admin',
            url: "/blog",
            templateUrl: "app/admin/sections/blog-post/blog-post.view.html",
            controller: 'BlogPostController',
            controllerAs: 'vm',
            ncyBreadcrumb: {
                label: 'Blog Posts'
            }
        })

        //////////////////////
        //  PANELS
        //////////////////////

        .state('blogPost-add', {
            parent: 'admin.blogPost',
            url: '/add',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/blog-post/blog-post-add-edit/blog-post-add-edit.view.html',
                    'BlogPostAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('blogPost-edit', {
            parent: 'admin.blogPost',
            url: '/:id',
            onEnter: function(panelService) {
                panelService.show(
                    'app/admin/sections/blog-post/blog-post-add-edit/blog-post-add-edit.view.html',
                    'BlogPostAddEditController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            },
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.blogPost')
        .controller('BlogPostController', BlogPostController);

    function BlogPostController($log, $scope, $state, $timeout, $rootScope, blogPostService, formsService, panelService, flashService, Notification) {
        var vm = this;

        vm.blogPosts = [];
        vm.getBlogPosts = getBlogPosts;
        vm.user = {};

        vm.itemsByPage = 10;
        var limit='';
        var page='';

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        //////////////////////
        //  GET
        //////////////////////
        function getBlogPosts(tableState) {

            vm.isTableLoading = true;

            var pagination = tableState.pagination;
            var selectedPage = pagination.start+1;
            //var sort = tableState.sort.predicate;
            var sort = '-created';  // sort newest first
            //$log.debug('tableState', tableState);
            //$log.debug('PAGINATION', pagination);

            //var sort = "";
            limit = vm.itemsByPage;            // Number of entries showed per page.
            page = selectedPage || 1;         // Current Page

            // get all blogPosts
            blogPostService.getAll(limit, page, sort).then(function(response) {

                if (response.data) {
                    //$log.debug('RESPONSE', response);

                    vm.blogPosts = response.data;
                    limit = response.items.limit;
                    page = response.pages.total;
                    tableState.pagination.numberOfPages = response.pages.total;

                    vm.isTableLoading = false;
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('admin.admins', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.admin-groups', []);

})();

(function() {
    'use strict';

    angular
        .module('admin.account')
        .factory('accountService', accountService);

    function accountService($log, API, apiHelperService) {

        var accounts = {};

        return {

            // GET
            getAll: getAll,
            getAllNotPaged: getAllNotPaged,
            getMy: getMy,
            getById: getById,
            getByUsername: getByUsername,
            searchByUsername: searchByUsername,

            // CREATE
            create: create,
            createNotesById: createNotesById,
            createStatusById: createStatusById,

            // UPDATE
            updateMy: updateMy,
            updateById: updateById,
            updateUsernameLinkById: updateUsernameLinkById,

            // DELETE
            deleteById: deleteById,
            deleteUsernameLinkById: deleteUsernameLinkById,

            invite: invite,

            // CACHE
            updateCache: updateCache,
            getCachedById: getCachedById
        };



        //////////////////////
        //  GET
        //////////////////////
        function getAll(limit, page, sort) {

            $log.debug("account-data: getAll()");

            var req = {
                method: 'GET',
                url: API.ACCOUNTS,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getAllNotPaged() {

            $log.debug("account-data: getAllNotPaged()");

            var req = {
                method: 'GET',
                url: API.ACCOUNTS + '/all'
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function getMy() {

            var req = {
                method: 'GET',
                url: API.ACCOUNTS +'/my',
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        function getById(id) {

            var req = {
                method: 'GET',
                url: API.ACCOUNTS + '/'+id,
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        function getByUsername(username) {

            var req = {
                method: 'GET',
                url: API.ACCOUNTS + '/'+username +'/profile',
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        function searchByUsername(username) {

            var req = {
                method: 'GET',
                url: API.ACCOUNTS + '/'+username +'/search',
            };
            return apiHelperService.sendHTTPRequest(req);

        }

        //////////////////////
        //  POST
        //////////////////////
        function create(account) {

            var req = {
                method: 'POST',
                url: API.ACCOUNTS,
                data: account
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function createNotesById(account) {

            var req = {
                method: 'POST',
                url: API.ACCOUNTS +'/'+ account.id +'/notes',
                data: account.notes
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function createStatusById(account) {

            var req = {
                method: 'POST',
                url: API.ACCOUNTS +'/'+ account.id +'/status',
                data: account.status
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  PUT
        //////////////////////
        function updateMy(account) {

            $log.debug('updateMy-account:', account);

            var req = {
                method: 'PUT',
                url: API.ACCOUNTS +'/my',
                data: {
                    name: {
                        first: account.first,
                        last: account.last
                    },
                    profileImage: account.profileImage
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function updateById(account) {

            $log.debug('updateById-account:', account);

            var req = {
                method: 'PUT',
                url: API.ACCOUNTS +'/'+ account.id,
                data: {
                    name: {
                        first: account.first,
                        last: account.last
                    }
                }
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function updateUsernameLinkById(account) {

            var req = {
                method: 'PUT',
                url: API.ACCOUNTS +'/'+ account.id +'/user',
                data: account.username
            };
            return apiHelperService.sendHTTPRequest(req);
        }


        //////////////////////
        //  DELETE
        //////////////////////
        function deleteById(account) {

            var req = {
                method: 'DELETE',
                url: API.ACCOUNTS +'/'+ account.id
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        function deleteUsernameLinkById(account) {

            var req = {
                method: 'DELETE',
                url: API.ACCOUNTS +'/'+ account.id +'/user'
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  INVITE
        //////////////////////
        function invite(account) {
            var req = {
                method: 'POST',
                url: API.ACCOUNTS + '/' + account.id + '/invite',
                data: account
            };
            return apiHelperService.sendHTTPRequest(req);
        }

        //////////////////////
        //  CACHE
        //////////////////////
        function updateCache(limit, page, sort) {
            var req = {
                method: 'GET',
                url: API.ACCOUNTS,
                params: {
                    //fields: fields,
                    sort: sort,
                    limit: limit,
                    page: page,
                }
            };
            return apiHelperService.sendHTTPRequest(req).then(function(result) {

                result.data.forEach(function(a) {
                    accounts[a._id] = a;
                });
                return result;
            });
        }

        function getCachedById(id) {
            return accounts[id];
        }
    }

})();

/*
 ** Factory for CRUDing API.ACCOUNTS
 */

(function() {
    'use strict';

    angular
        .module('admin.account')
        .config(accountRouteConfig);

    function accountRouteConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  ACCOUNTS
        //////////////////////
        .state('admin.account', {
            parent: 'admin',
            url: "/accounts",
            templateUrl: "app/admin/sections/account/account.view.html",
            controller: 'AccountController',
            controllerAs: 'vm',
            ncyBreadcrumb: {
                label: 'Accounts'
            }
        })

        //////////////////////
        //  PANELS
        //////////////////////

        .state('account-add', {
            parent: 'admin.account',
            url: '/add',
            onEnter: function(panelService) {
                onEnter: panelService.show(
                    'app/admin/sections/account/account-add/account-add.view.html',
                    'AccountAddController'
                )
            },
            ncyBreadcrumb: {
                skip: true
            }
        })

        .state('account-edit', {
            parent: 'admin.account',
            url: '/:id',
            onEnter: function(panelService) {
                onEnter: panelService.show(
                    'app/admin/sections/account/account-edit/account-edit.view.html',
                    'AccountEditController'
                )
            },          
            ncyBreadcrumb: {
                skip: true
            },
        })

        //////////////////////
        //  404
        //////////////////////
        // .state('admin.notfound', {
        //     parent: 'admin',
        //     url: '*path',
        //     templateUrl: 'app/admin/admin-404.view.html',
        //     title: 'Page Not Found',
        //     ncyBreadcrumb: {
        //         skip: true
        //     },
        // });

    }

})();

(function() {
    'use strict';

    angular
        .module('admin.account')
        .controller('AccountController', AccountController);

    function AccountController($log, $scope, $state, $timeout, $rootScope, accountService, formsService, panelService, flashService, Notification, authService) {
        var vm = this;

        vm.accounts = [];
        vm.getAccounts = getAccounts;
        vm.user = {};

        vm.itemsByPage = 10;
        var limit='';
        var page='';

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        $scope.isAdmin = authService.isAdmin;

        //////////////////////
        //  GET
        //////////////////////
        function getAccounts(tableState) {

            vm.isTableLoading = true;

            var pagination = tableState.pagination;
            var selectedPage = pagination.start+1;
            //var sort = tableState.sort.predicate;
            var sort = '-timeCreated';  // sort newest first
            //$log.debug('tableState', tableState);
            //$log.debug('PAGINATION', pagination);

            //var sort = "";
            limit = vm.itemsByPage;            // Number of entries showed per page.
            page = selectedPage || 1;         // Current Page

            // get all accounts
            accountService.getAll(limit, page, sort).then(function(response) {

                if (response.data) {
                    //$log.debug('RESPONSE', response);

                    vm.accounts = response.data;
                    limit = response.items.limit;
                    page = response.pages.total;
                    tableState.pagination.numberOfPages = response.pages.total;

                    vm.isTableLoading = false;
                }
            });
        }




    }

})();

(function() {
'use strict';

	angular
		.module('login', []);

})();


(function() {
    'use strict';

    angular
        .module('login')
        .controller('LoginResetController', LoginResetController);

    function LoginResetController($scope, $rootScope, $log, $location, $q, Session,
                                  authService, flashService, formsService) {

        var vm = this;

        //region ViewModel Properties
        vm.password = "";
        vm.confirmPassword = "";
        vm.token = "";
        vm.valid = false;
        //endregion


        //region ViewModel Methods
        vm.resetPassword = resetPassword;
        vm.isPasswordConfirmed = isPasswordConfirmed;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;
        //endregion

        (function init() {
            // reset login status - ensure user is logged out on controller load
            // user should never get to /activate-account when authenticated - this is precaution
            Session.destroy();
            Session.token=null;

            // if the user was directed here via a link with a key, then activate their account
            if ($location.search().token) {
                vm.valid = true;
                vm.token = $location.search().token;
            }
            else {
                $log.error("LoginResetController.init-error:", "no token");
                flashService.error("The link you used did not contain a token. Please click on the link in your email to " +
                    "reset your password, or proceed to the login page to request a new email.");
            }
        })();


        function resetPassword() {
            $rootScope.isDataLoading = true;
            authService.loginReset({
                token: vm.token,
                password: vm.password
            })
                .then(function(response) {
                    $log.debug("LoginResetController.resetPassword-success:", response);

                    $scope.resetForm.$setPristine();
                    vm.user = {};
                    vm.success = true;
                    flashService.success('Your password has been reset. Please login to confirm.');
                    vm.valid = false;
                    $rootScope.isDataLoading = false;
                })
                .catch(function(error) {

                    $log.error("LoginResetController.resetPassword-error:", error);

                    if (error.data.message === 'Invalid email or key.') {
                        flashService.error("The token in your email link has expired, " +
                            "proceed to the login page to request a new email.");
                    }
                    else {
                        flashService.error("There was an error during the activation process, please try again.");
                    }
                    vm.valid = false;
                    $rootScope.isDataLoading = false;
                });
        }

        function isPasswordConfirmed (passwordConfirmation) {
            return $q(function (resolve, reject) {
                if (passwordConfirmation == vm.password) {
                    resolve();
                } else {
                    reject();
                }
            });
        }


    }

})();

(function() {
    'use strict';

    angular
        .module('login')
        .factory('loginModalService', loginModalService);

    function loginModalService($log, $q, $rootScope, $state, $modal, REDIRECT) {

        return {
            show: show,
            hide: hide     
        }

        var loginModal = null;

        /////////////////////////
        //  OPEN LOGIN MODAL
        /////////////////////////
        function show() {

            $log.debug("login.modal.service: show");

            if (loginModal) {
                $log.debug("login.modal.service: instance already exists - multiple requests?");
                return $q.reject();
            }

            loginModal = $modal({
                templateUrl: 'app/login/modal/login-modal.view.html',
                controller: 'LoginModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,    // ensure the user cant press escape
                show: false,
                onHide: function() {
                    hide();
                }
            });

            return loginModal.$promise.then(loginModal.show);
        }

        ////////////////////////////////
        //  CLOSE / CANCEL LOGIN MODAL
        ////////////////////////////////
        function hide() {

            if (loginModal) {
                $log.debug("login.modal.service: hide");
                loginModal.hide();
                loginModal = null;
            }
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('login')
        .controller('LoginModalController', LoginModalController);

    function LoginModalController($scope, $rootScope, $state, $timeout, $log, authService, formsService, Session, loginModalService, flashService, REDIRECT) {

        var vm = this;
        vm.user = {};
        vm.modalLogin = modalLogin;
        vm.closeLoginModal = closeLoginModal;


        function modalLogin() {

            $rootScope.isDataLoading = true;

            authService.login(vm.user)
                .then(function(response) {

                    $log.debug("login.modal.controller-success:", response);

                    // broadcast login event
                    // set user in main controller global - rootscope so we can set from anywhere
                    $rootScope.setUserId(response.data.user._id); 
                    $rootScope.setUsername(response.data.user.username); 
                    $rootScope.setFullname(response.data.user.roles.account.name);

                    // close modal
                    loginModalService.hide();

                    // if (authService.isAuthorized('admin')) {
                    //     //$log.debug("login.modal.controller-isAuthorized: IS Admin");
                    //     $state.go(REDIRECT.ADMIN);           
                    // }
                    // else {
                        //$log.debug("login.modal.controller-isAuthorized: NOT Admin");
                        $state.go(REDIRECT.ADMIN);
                        $timeout(function() {
                            $state.reload();
                        });
                    //}

                }, function(error) {

                    //$log.error("loginModal.controller-error:", error.data);
                    flashService.error(error.data.message);

                });   
        }

        function closeLoginModal() {
            // cancel button in modal login was clicked
            //$log.debug("login.modal.controller: closeLoginModal");
            loginModalService.hide();
            $state.go(REDIRECT.LOGIN);
        };
    }

})();

// The LoginModalController provides the behaviour behind a reusable form to allow users to authenticate.
// This controller and its template (login/modal/login-modal.view.html) are used in a modal dialog box by the auth service.
(function() {
    'use strict';

    angular
        .module('login')
        .controller('LoginForgotController', LoginForgotController);

    function LoginForgotController($scope, $rootScope, $log, authService, flashService, formsService) {

        var vm = this;
        vm.forgot = forgot;
        vm.email = "";

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;


        function forgot() {

            $rootScope.isDataLoading = true;

            authService.loginForgot(vm.email)
                .then(function(response) {

                    $scope.loginForgotForm.$setPristine();
                    vm.email = "";

                    $log.debug("loginForgot.controller-success:", response);
                    flashService.info('If an account matched that address, an email will be sent with instructions.');

                }, function(error) {

                    $log.error("loginForgot.controller-error:", error.data);
                    flashService.error('Error resetting your account, please try again.');
                });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.services', [
            'app.services.auth',
            'app.services.utility',
            'app.services.highlight'
        ]);

})();

(function() {
    'use strict';

    angular
        .module('app.filters', []);

})();

(function() {
    'use strict';

    angular
        .module('app.filters')
        .filter('phonenumberFilter', phonenumberFilter);

    function phonenumberFilter() {

        return function(tel) {
            if (!tel) {
                return '';
            }

            var value = tel.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return tel;
            }

            var country, city, number;

            switch (value.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                default:
                    return tel;
            }

            if (country == 1) {
                country = "";
            }

            number = number.slice(0, 3) + '-' + number.slice(3);

            return (country + " (" + city + ") " + number).trim();
        }
    }


    function Ctrl($scope) {
        $scope.phoneNumber = 4085265552;
    }

})();

(function() {
    'use strict';

    angular
        .module('app.filters')
        .filter('formatTime', formatTime);

    function formatTime() {

        return function(timestamp, withtime) {
            if (!timestamp)
                return;

            if (withtime) {
                return moment(timestamp).format('lll');   // Jan 12, 2017
            }

            return moment(timestamp).format('ll');   // Jan 12, 2017

            // below returns eg. 5 days ago
            //var res = moment(timestamp).from();
            //return replace ? res.replace('ago', replace) : res;
        }
    }



})();

(function() {
    'use strict';

    angular
        .module('app.filters')
        .filter('capitalize', capitalize);

    function capitalize() {

        return function(input, scope) {
            if (input !=null) {
                if (input.length>=1) {
                    input = input.toLowerCase();
                    return input.substring(0, 1).toUpperCase() + input.substring(1);
                }
            }
        }
    }



})();

(function() {
    'use strict';

    angular
        .module('app.directives', []);

})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        // .directive('pageTitle', pageTitle)
        // .directive('sideNavigation', sideNavigation)
        // .directive('iboxTools', iboxTools)
        // .directive('minimalizaSidebar', minimalizaSidebar)
        // .directive('vectorMap', vectorMap)
        // .directive('sparkline', sparkline)
        // .directive('icheck', icheck)
        // .directive('ionRangeSlider', ionRangeSlider)
        // .directive('dropZone', dropZone)
        // .directive('responsiveVideo', responsiveVideo)
        // .directive('chatSlimScroll', chatSlimScroll)
        // .directive('customValid', customValid)
        // .directive('fullScroll', fullScroll)
        // .directive('closeOffCanvas', closeOffCanvas)
        // .directive('clockPicker', clockPicker)
        // .directive('landingScrollspy', landingScrollspy)
        // .directive('fitHeight', fitHeight)
        // .directive('iboxToolsFullScreen', iboxToolsFullScreen)
        // .directive('slimScroll', slimScroll)
        // .directive('truncate', truncate)
        // .directive('touchSpin', touchSpin)
        // .directive('markdownEditor', markdownEditor)
        .directive('categoryName', categoryName)
        .directive('categorySelect', categorySelect)
        .directive('categoryMultiSelect', categoryMultiSelect)
        // .directive('categoryToggle', categoryToggle)
        .directive('highlightSelect', highlightSelect)
        .directive('topnavcollapse', topNavCollapse)
        .directive('userEmail', userEmail);



    /**
     * pageTitle - Directive for set Page title - mata title
     */
    function pageTitle($rootScope, $timeout) {
        return {
            link: function(scope, element) {
                var listener = function(event, toState, toParams, fromState, fromParams) {
                    // Default title - load on Dashboard 1
                    var title = 'Twist';
                    // Create your own title pattern
                    if (toState.data && toState.data.pageTitle) title = 'Twist | ' + toState.data.pageTitle;
                    $timeout(function() {
                        element.text(title);
                    });
                };
                $rootScope.$on('$stateChangeStart', listener);
            }
        }
    };

    /**
     * sideNavigation - Directive for run metsiMenu on sidebar navigation
     */
    function sideNavigation($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                // Call the metsiMenu plugin and plug it to sidebar navigation
                $timeout(function() {
                    element.metisMenu();

                });
            }
        };
    };

    /**
     * responsibleVideo - Directive for responsive video
     */
    function responsiveVideo() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                var figure = element;
                var video = element.children();
                video
                    .attr('data-aspectRatio', video.height() / video.width())
                    .removeAttr('height')
                    .removeAttr('width')

                //We can use $watch on $window.innerWidth also.
                $(window).resize(function() {
                    var newWidth = figure.width();
                    video
                        .width(newWidth)
                        .height(newWidth * video.attr('data-aspectRatio'));
                }).resize();
            }
        }
    }

    /**
     * iboxTools - Directive for iBox tools elements in right corner of ibox
     */
    function iboxTools($timeout) {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'app/main/main-ibox_tools.view.html',
            controller: function($scope, $element) {
                // Function for collapse ibox
                $scope.showhide = function() {
                    var ibox = $element.closest('div.ibox');
                    var icon = $element.find('i:first');
                    var content = ibox.find('div.ibox-content');
                    content.slideToggle(200);
                    // Toggle icon from up to down
                    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                    ibox.toggleClass('').toggleClass('border-bottom');
                    $timeout(function() {
                        ibox.resize();
                        ibox.find('[id^=map-]').resize();
                    }, 50);
                };
                // Function for close ibox
                $scope.closebox = function() {
                    var ibox = $element.closest('div.ibox');
                    ibox.remove();
                }
            }
        };
    }

    /**
     * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
     */
    function iboxToolsFullScreen($timeout) {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'app/main/main-ibox_tools_full_screen.view.html',
            controller: function($scope, $element) {
                // Function for collapse ibox
                $scope.showhide = function() {
                    var ibox = $element.closest('div.ibox');
                    var icon = $element.find('i:first');
                    var content = ibox.find('div.ibox-content');
                    content.slideToggle(200);
                    // Toggle icon from up to down
                    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                    ibox.toggleClass('').toggleClass('border-bottom');
                    $timeout(function() {
                        ibox.resize();
                        ibox.find('[id^=map-]').resize();
                    }, 50);
                };
                // Function for close ibox
                $scope.closebox = function() {
                    var ibox = $element.closest('div.ibox');
                    ibox.remove();
                };
                // Function for full screen
                $scope.fullscreen = function() {
                    var ibox = $element.closest('div.ibox');
                    var button = $element.find('i.fa-expand');
                    $('body').toggleClass('fullscreen-ibox-mode');
                    button.toggleClass('fa-expand').toggleClass('fa-compress');
                    ibox.toggleClass('fullscreen');
                    setTimeout(function() {
                        $(window).trigger('resize');
                    }, 100);
                }
            }
        };
    }

    /**
     * minimalizaSidebar - Directive for minimalize sidebar
     */
    function minimalizaSidebar($timeout) {
        return {
            restrict: 'A',
            //template: '<a class="navbar-minimalize " href="" ng-click="minimalize()"><i class="fa fa-sun-o fa-3x"></i></a>',
            template: '<div class="navbar-minimalize " href="" ng-click="minimalize()"><i class="material-icons menu-icon">menu</i></div>',

            controller: function($scope, $element) {
                $scope.minimalize = function() {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function() {
                            angular.element('#side-menu').fadeIn(500);
                        }, 100);
                    }
                    else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    };


    function closeOffCanvas() {
        return {
            restrict: 'A',
            template: '<a class="close-canvas-menu" ng-click="closeOffCanvas()"><i class="fa fa-times"></i></a>',
            controller: function($scope, $element) {
                $scope.closeOffCanvas = function() {
                    $("body").toggleClass("mini-navbar");
                }
            }
        };
    }

    /**
     * vectorMap - Directive for Vector map plugin
     */
    function vectorMap() {
        return {
            restrict: 'A',
            scope: {
                myMapData: '=',
            },
            link: function(scope, element, attrs) {
                var map = element.vectorMap({
                    map: 'world_mill_en',
                    backgroundColor: "transparent",
                    regionStyle: {
                        initial: {
                            fill: '#e4e4e4',
                            "fill-opacity": 0.9,
                            stroke: 'none',
                            "stroke-width": 0,
                            "stroke-opacity": 0
                        }
                    },
                    series: {
                        regions: [{
                            values: scope.myMapData,
                            scale: ["#1ab394", "#22d6b1"],
                            normalizeFunction: 'polynomial'
                        }]
                    },
                });
                var destroyMap = function() {
                    element.remove();
                };
                scope.$on('$destroy', function() {
                    destroyMap();
                });
            }
        }
    }


    /**
     * sparkline - Directive for Sparkline chart
     */
    function sparkline() {
        return {
            restrict: 'A',
            scope: {
                sparkData: '=',
                sparkOptions: '=',
            },
            link: function(scope, element, attrs) {
                scope.$watch(scope.sparkData, function() {
                    render();
                });
                scope.$watch(scope.sparkOptions, function() {
                    render();
                });
                var render = function() {
                    $(element).sparkline(scope.sparkData, scope.sparkOptions);
                };
            }
        }
    };

    /**
     * icheck - Directive for custom checkbox icheck
     */
    function icheck($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function($scope, element, $attrs, ngModel) {
                return $timeout(function() {
                    var value;
                    value = $attrs['value'];

                    $scope.$watch($attrs['ngModel'], function(newValue) {
                        $(element).iCheck('update');
                    })

                    return $(element).iCheck({
                        checkboxClass: 'icheckbox_square-green',
                        radioClass: 'iradio_square-green'

                    }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
                });
            }
        };
    }

    /**
     * ionRangeSlider - Directive for Ion Range Slider
     */
    function ionRangeSlider() {
        return {
            restrict: 'A',
            scope: {
                rangeOptions: '='
            },
            link: function(scope, elem, attrs) {
                elem.ionRangeSlider(scope.rangeOptions);
            }
        }
    }

    /**
     * dropZone - Directive for Drag and drop zone file upload plugin
     */
    function dropZone() {
        return {
            restrict: 'C',
            link: function(scope, element, attrs) {

                var config = {
                    url: 'http://localhost:8080/upload',
                    maxFilesize: 100,
                    paramName: "uploadfile",
                    maxThumbnailFilesize: 10,
                    parallelUploads: 1,
                    autoProcessQueue: false
                };

                var eventHandlers = {
                    'addedfile': function(file) {
                        scope.file = file;
                        if (this.files[1] != null) {
                            this.removeFile(this.files[0]);
                        }
                        scope.$apply(function() {
                            scope.fileAdded = true;
                        });
                    },

                    'success': function(file, response) {}

                };

                dropzone = new Dropzone(element[0], config);

                angular.forEach(eventHandlers, function(handler, event) {
                    dropzone.on(event, handler);
                });

                scope.processDropzone = function() {
                    dropzone.processQueue();
                };

                scope.resetDropzone = function() {
                    dropzone.removeAllFiles();
                }
            }
        }
    }

    /**
     * chatSlimScroll - Directive for slim scroll for small chat
     */
    function chatSlimScroll($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.slimscroll({
                        height: '234px',
                        railOpacity: 0.4
                    });

                });
            }
        };
    }

    /**
     * customValid - Directive for custom validation example
     */
    function customValid() {
        return {
            require: 'ngModel',
            link: function(scope, ele, attrs, c) {
                scope.$watch(attrs.ngModel, function() {

                    // You can call a $http method here
                    // Or create custom validation

                    var validText = "Twist";

                    if (scope.extras == validText) {
                        c.$setValidity('cvalid', true);
                    }
                    else {
                        c.$setValidity('cvalid', false);
                    }

                });
            }
        }
    }


    /**
     * fullScroll - Directive for slimScroll with 100%
     */
    /**
    function fullScroll($timeout){
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function(){
                    element.slimscroll({
                        height: '100%',
                        railOpacity: 0.9
                    });

                });
            }
        };
    }
    **/
    /**
     * slimScroll - Directive for slimScroll with custom height
     */
    /**
    function slimScroll($timeout){
        return {
            restrict: 'A',
            scope: {
                boxHeight: '@'
            },
            link: function(scope, element) {
                $timeout(function(){
                    element.slimscroll({
                        height: scope.boxHeight,
                        railOpacity: 0.9
                    });

                });
            }
        };
    }
    **/
    /**
     * clockPicker - Directive for clock picker plugin
     */
    function clockPicker() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.clockpicker();
            }
        };
    };


    /**
     * landingScrollspy - Directive for scrollspy in landing page
     */
    function landingScrollspy() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.scrollspy({
                    target: '.navbar-fixed-top',
                    offset: 80
                });
            }
        }
    }

    /**
     * fitHeight - Directive for set height fit to window height
     */
    function fitHeight() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                element.css("height", $(window).height() + "px");
                element.css("min-height", $(window).height() + "px");
            }
        };
    }

    /**
     * truncate - Directive for truncate string
     */
    function truncate($timeout) {
        return {
            restrict: 'A',
            scope: {
                truncateOptions: '='
            },
            link: function(scope, element) {
                $timeout(function() {
                    element.dotdotdot(scope.truncateOptions);

                });
            }
        };
    }


    /**
     * touchSpin - Directive for Bootstrap TouchSpin
     */
    function touchSpin() {
        return {
            restrict: 'A',
            scope: {
                spinOptions: '='
            },
            link: function(scope, element, attrs) {
                scope.$watch(scope.spinOptions, function() {
                    render();
                });
                var render = function() {
                    $(element).TouchSpin(scope.spinOptions);
                };
            }
        }
    };

    /**
     * markdownEditor - Directive for Bootstrap Markdown
     */
    function markdownEditor() {
        return {
            restrict: "A",
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                $(element).markdown({
                    savable: false,
                    onChange: function(e) {
                        ngModel.$setViewValue(e.getContent());
                    }
                });
            }
        }
    }

    function categoryName(categoryService) {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                id: '@'
            },
            template: '<span>{{category.name}}</span>',
            link: function(scope, elem) {
                categoryService.getById(scope.id).then(function(response){
                    scope.category = response;
                });
            }
        }
    }

    function categorySelect(categoryService) {
        return {
            replace: true,
            restrict: 'E',
            scope: {
                selectedCategoryId: '='
            },
            template:
            '<select name="categoryId" id="categoryId" ng-model="selectedCategoryId" class="form-control input-lg" required>' +
            '<option value="">-- Select a Category --</option>' +
            '<option ng-repeat="category in categories" value="{{category._id}}">{{category.name}}</option>' +
            '</select>',
            link: function(scope, elem) {
                categoryService.getAll(1000, 1, '+name').then(function(response) {
                    if (response.data) {
                        scope.categories = response.data;
                    }
                });
            }
        }
    }

    function categoryMultiSelect(categoryService) {
        return {
            replace: true,
            restrict: 'E',
            scope: {
                selectedCategoryIds: '='
            },
            template:
            '<select multiple name="categoryId" id="categoryId" ng-model="selectedCategoryIds" class="form-control input-lg" required>' +
            '   <option ng-repeat="category in categories" value="{{category._id}}">{{category.name}}</option>' +
            '</select>',
            link: function(scope, elem) {
                categoryService.getAll(1000, 1, '+name').then(function(response) {
                    if (response.data) {
                        scope.categories = response.data;
                    }
                });
            }
        }
    }


    function categoryToggle(categoryService) {
        return {
            replace: false,
            restrict: 'E',
            scope: {
                categories: '=',
                onChange: '='
            },
            template:
            '<span ng-click="onClick()" ng-repeat="category in categories">' +
            '<button type="button" class="btn btn-primary-cat m-t-xs m-r-xs" ng-model="category.selected" bs-checkbox>{{category.name}}</button>' +
            '</span>',
            controller: function($scope) {
                categoryService.getAll(1000, 1, '+name').then(function(response) {
                    if (response.data) {
                        $scope.categories = response.data;
                        // fire change handler once with all categories for default state
                        $scope.onChange($scope.categories);
                    }
                });
                $scope.onClick = function() {
                    $scope.onChange($scope.categories.filter(function(c) { return c.selected === true }));
                }
            }
        }
    }

    function highlightSelect(highlightService, Notification, $log) {
        return {
            replace: true,
            restrict: 'E',
            scope: {
                highlight: '='
            },
            template:
            '<div>' +
            '   <label>Set as Highlight</label>' +
            '   <select name="highlightIndex" id="highlightIndex" ng-model="selectedHighlightIndex" ng-change="selectionChanged(selectedHighlightIndex)" class="form-control input-lg">' +
            '       <option value="">-- Select Highlight --</option>' +
            '       <option ng-repeat="highlight in highlights" value="{{$index + 1}}">Highlight {{$index + 1}}</option>' +
            '   </select>' +
            '   <button ng-if="(selectedHighlightIndex > 0)" class="m-t btn btn-success" ng-click="saveHighlight()">Set Highlight</button>' +
            '</div>',
            controller: function($scope) {
                $scope.highlights = [{}, {}, {}];
                $scope.selectionChanged = function(h) {
                    $scope.highlight.index = h;
                };
                $scope.saveHighlight = function() {
                    $log.debug('$scope.highlight', $scope.highlight);
                    highlightService.updateByIndex($scope.highlight).then(function(r) {
                        if (!r.message) {
                            Notification.success("Highlight " + $scope.highlight.index + " Successfully Updated.");
                        } else {
                            Notification.error("Failed to set News Item as Highlight " + $scope.highlight.index + ".");
                        }
                    });
                }
            }
        }
    }

    /**
     * topNavCollapse - Directive to collapse and change look of header navbar on scroll
     */
    function topNavCollapse($window) {
        //console.log('topNavCollapse');
        return function(scope, element, attrs) {
            angular.element($window).bind("scroll", function() {
                 if (this.pageYOffset >= 100) {
                     scope.boolChangeClass = true;
                     //console.log('Scrolled below header.');
                 } else {
                     scope.boolChangeClass = false;
                     //console.log('Header is in view.');
                 }
                scope.$apply();
            });
        };
    };

    function userEmail(userService) {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                id: '@'
            },
            template: '<span>{{user.email}}</span>',
            link: function(scope, elem) {
                scope.user = userService.getCachedById(scope.id);
            }
        }
    }
})();

/**
 *
 * Main directives.js file
 * Define directives for used plugin
 *
 *
 * Functions (directives)
 *  - sideNavigation
 *  - iboxTools
 *  - minimalizaSidebar
 *  - vectorMap
 *  - sparkline
 *  - icheck
 *  - ionRangeSlider
 *  - dropZone
 *  - responsiveVideo
 *  - chatSlimScroll
 *  - customValid
 *  - fullScroll
 *  - closeOffCanvas
 *  - clockPicker
 *  - landingScrollspy
 *  - fitHeight
 *  - iboxToolsFullScreen
 *  - slimScroll
 *  - truncate
 *  - touchSpin
 *  - markdownEditor
 *  - resizeable
 *
 */

(function() {
'use strict';

	angular
		.module('signup', []);

})();


(function() {
    'use strict';

    angular
        .module('signup')
        .config(routeConfig);

    function routeConfig($stateProvider) {

        $stateProvider

        .state('signup', {
            url: "/signup?invitationToken",
            templateUrl: 'app/signup/signup.view.html',
            controller: 'SignupController',
            controllerAs: 'vm',
            title: 'Sign Up',
            resolve: {
                signup: function(authSecurityService) {
                    return authSecurityService.requireUnauthenticatedUser();
                }
            }
        })

    }
})();

(function() {
    'use strict';

    angular
        .module('signup')
        .controller('SignupController', SignupController);

    function SignupController($scope, $rootScope, $stateParams, $log, authService, Session, formsService, flashService) {

        var vm = this;
        vm.signup = signup;
        vm.user = {};
        vm.invitationToken = $stateParams.invitationToken;

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;


        (function init() {
            // reset login status - ensure user is logged out on controller load
            // user should never get to /signup when authenticaed - this is precaution
            Session.destroy();
            Session.token=null;
            if(vm.invitationToken) {
                authService.getInvitation(vm.invitationToken).then(
                    function(invitation) {
                        if(invitation) {
                            vm.user.email = invitation.to;
                        } else {
                            vm.invitationToken = null;
                        }
                    }
                );
            }
        })();


        function signup() {

            $rootScope.isDataLoading = true;

            authService.signup(vm.user, vm.invitationToken)
                .then(function(response) {

                    $log.debug("signup.controller-success:", response);
                    flashService.success('Signup Success');

                    // set user in main controller global - rootscope so we can set from anywhere
                    $rootScope.setUserId(response.data.user._id);
                    $rootScope.setUsername(response.data.user.username);
                    $rootScope.setFullname(response.data.user.roles.account.name);

                }, function(error) {

                    $log.error("signup.controller-error:", error.data);
                    flashService.error(error.data.message);

                });
        }
    };
})();

(function() {
    'use strict';

    angular
        .module('login')
        .config(routeConfig);

    function routeConfig($stateProvider) {

        $stateProvider

        .state('login', {
            url: "/login",
            templateUrl: 'app/login/login.view.html',
            controller: 'LoginController',
            controllerAs: 'vm',
            title: 'Login',
            resolve: {
                login: function(authSecurityService) {
                    return authSecurityService.requireUnauthenticatedUser()
                }
            }
        })

        .state('forgotpw', {
            url: "/login/forgot",
            templateUrl: 'app/login/forgot/login-forgot.view.html',
            controller: 'LoginForgotController',
            controllerAs: 'vm',
            title: 'Forgot Password',
            resolve: {
                forgotpw: function(authSecurityService) {
                    return authSecurityService.requireUnauthenticatedUser()
                }
            }
        })

        .state('resetpw', {
            url: '/login/reset',
            templateUrl: 'app/login/reset/login-reset.view.html',
            controller: 'LoginResetController',
            controllerAs: 'vm',
            title: 'Reset Password',
            resolve: {
                resetpw: function(authSecurityService) {
                    return authSecurityService.requireUnauthenticatedUser()
                }
            }
        })

        .state('resetpwtoken', {
            url: '/login/reset/?token',
            templateUrl: 'app/login/reset/login-reset.view.html',
            controller: 'LoginResetController',
            controllerAs: 'vm'
        })

        // 404
        // .state('notfoundlogin', {
        //     url: '/*path',
        //     templateUrl: 'app/404.view.html',
        //     title: 'Page Not Found',
        //     ncyBreadcrumb: {
        //         skip: true
        //     },
        // });

    }


})();

(function() {
    'use strict';

    angular
        .module('login')
        .controller('LoginController', LoginController);

    function LoginController($scope, $rootScope, $state, $log, authService, Session, formsService, flashService, REDIRECT, userService) {

        var vm = this;
        vm.login = login;
        vm.user = {};

        // error handling utility
        $scope.hasError = formsService.hasError;
        $scope.showError = formsService.showError;
        $scope.canSave = formsService.canSave;

        (function init() {
            // reset login status - ensure user is logged out on controller load
            // user should never get to /login when authenticaed - this is precaution
            //Session.destroy();
            //Session.token=null;
        })();

        function login() {

            $rootScope.isDataLoading = true;

            authService.login(vm.user)
                .then(function(response) {

                    $log.debug("login.controller-success:", response);
                    flashService.success('Login Success!');

                    // set user in main controller global - rootscope so we can set from anywhere
                    $rootScope.setUserId(response.data.user._id);
                    $rootScope.setUsername(response.data.user.username);
                    //$rootScope.setFullname(response.data.user.roles.account.name);

                    // go to main page
                    var go = function() {
                        $state.go(REDIRECT.ADMIN);
                    };

                    if(authService.isAdmin()) {
                        userService.updateCache().then(go);
                    } else {
                        go();
                    }
                }, function(error) {

                    $log.error("login.controller-error:", error.data);
                    flashService.error(error.data.message);

                });
        }
    }

})();

(function() {
    'use strict';

    angular.module('admin', []);

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('AdminController', AdminController);

    function AdminController($log, $scope, $state, $stateParams, $rootScope, authService, Session, ENV_VARS, REDIRECT) {
        var vm = this;

        // init globals for app wide inheritance
        vm.currentUser = Session.userName;
        
        vm.login = login;
        vm.logout = logout;



        //////////////////////
        //  LOGIN / LOGOUT
        //////////////////////
        function login() {
            $log.debug("admin.controller-login()");
            authService.login();
        };

        function logout() {
            $log.debug("admin.controller-logout()");
            authService.logout();
        };


        //////////////////////
        //  GLOBAL ENV VARS
        //////////////////////

        // app name from gulp file json
        $rootScope.appName = ENV_VARS.appName;

        // app name from gulp file json
        $rootScope.appDesc = ENV_VARS.appDesc;

        //////////////////////
        //  GLOBAL MAIN VARS
        //////////////////////

        // we set these for login/signup
        $rootScope.setUserId = function(userId) {
            $rootScope.userId = userId;
        };
        $rootScope.setUsername = function(username) {
            $rootScope.username = username;
        };
        $rootScope.setFullname = function(fullname) {
            $rootScope.fullname = fullname;
        };

        //$log.debug("Session", Session);

        $rootScope.username='';
        $rootScope.fullname='';

        // we set these for page refresh
        if (authService.isAuthenticated()) {
            if (Session.userId) {
                $rootScope.userId = Session.userId;
            }
            if (Session.userName) {
                $rootScope.username = Session.userName;
            }
            if (Session.userRole.account) {
                $rootScope.fullname = Session.userRole.account.name;
            }
        }


        $scope.isAuthenticated = function() {
            return authService.isAuthenticated();
        };

        $scope.isAuthorized = function(role) {
            return authService.isAuthorized(role);
        };

        $scope.isActive = function(stateLocation) {
            //$log.debug("main.controller-state:", $state.current.name);
            return $state.current.name === stateLocation;
        };




        ///////////////////////////////
        //  BODY ID - CSS IDENTIFIER
        ///////////////////////////////
        vm.bodyId = '';
        // set unique id on body tag for any state we specify in routes files
        $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            if (toState.data && toState.data.bodyId) {
                //$log.debug("main.controller: toState.data.bodyId",toState.data.bodyId);
                var bid = toState.data.bodyId;
                if (bid) {
                    vm.bodyId = toState.data.bodyId;
                    return;
                }
            }
            else {
                vm.bodyId = '';
            }
        });





    };

})();

(function () {
    'use strict';

    angular
      .module('app', [
        'ngAnimate',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ui.router',
        'ngMask',
        'uiSwitch',
        'ui.slimscroll',
        'ngAutocomplete',
        'ui-notification',
        'LocalStorageModule',
        'ngFileUpload',
        'angularTrix',
        'ncy-angular-breadcrumb',
        'mgcrea.ngStrap',
        'ui.bootstrap',
        'smart-table',
        'angular-flot',
        // setup
        'app.env',
        'app.directives',
        'app.filters',
        'app.services',
        // login
        'login',
        'signup',
        // admin
        'admin',
        'admin.user',
        'admin.account',
        'admin.category',
        'admin.event',
        'admin.blogPost',
        'admin.newsItem',
        'admin.pressRelease',
        'admin.teamMember',
        'admin.leadership'
      ]);
  }
)();

(function() {
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    function runBlock($log, $http, $rootScope, $state, $stateParams, Notification, authService, userService, accountService) {

        // GET EXISTING SESSION
        // persist user session data on page refresh
        authService.getSession();

        if(authService.isAuthenticated() && authService.isAdmin()) {
            userService.updateCache();
            accountService.updateCache();
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider

        //////////////////////
        //  ADMIN
        //////////////////////
        .state('admin', {
            url: "",
            templateUrl: "app/admin/admin.view.html",
            ncyBreadcrumb: {
                skip: true
            },
            data: {
                bodyId: 'admin'
            }
        })

        .state('admin-home', {
            url: "/",
            templateUrl: "app/admin/admin.view.html",
            ncyBreadcrumb: {
                skip: true
            },
            data: {
                bodyId: 'admin-home'
            },
            resolve: {
                admin: function(authSecurityService) {
                    return authSecurityService.requireAdminUser();
                }
            }
        })

        // .state('admin.dashboard', {
        //     parent: 'admin',
        //     url: "/dashboard",
        //     templateUrl: "app/admin/sections/dashboard/dashboard.view.html",
        //     controller: 'DashboardController',
        //     controllerAs: 'vm',
        //     data: {
        //         bodyId: 'dashboard'
        //     },
        //     ncyBreadcrumb: {
        //         label: 'Dashboard'
        //     }
        // });


        // 404
        .state('notfound', {
            parent: 'admin',
            url: '/*path',
            templateUrl: 'app/admin/admin-404.view.html',
            title: 'Page Not Found',
            ncyBreadcrumb: {
                skip: true
            },
            resolve: {
            admin: function(authSecurityService) {
                return authSecurityService.requireAdminUser();
            }
        }
        });

    }

})();

angular.module("app.env", [])
.constant("ENV_VARS", {
    "appName": "Twist",
    "appDesc": "",
    "apiUrl": "https://twist-api.scaliolabs.com/",
    "version": "1.0.0"
})
.constant("AWS_S3_UPLOAD", {
    "AWSAccessKeyId": "AKIAIZBC4YX6KJZPPXVA",
    "policy": "ewogICJleHBpcmF0aW9uIjogIjIwMjAtMDEtMDFUMDA6MDA6MDBaIiwKICAiY29uZGl0aW9ucyI6IFsKICAgIHsiYnVja2V0IjogImNkbi10d2lzdGJpbyJ9LAogICAgWyJzdGFydHMtd2l0aCIsICIka2V5IiwgIiJdLAogICAgeyJhY2wiOiAicHVibGljLXJlYWQifSwKICAgIFsic3RhcnRzLXdpdGgiLCAiJENvbnRlbnQtVHlwZSIsICIiXSwKICAgIFsic3RhcnRzLXdpdGgiLCAiJGZpbGVuYW1lIiwgIiJdLAogICAgWyJjb250ZW50LWxlbmd0aC1yYW5nZSIsIDAsIDUyNDI4ODAwMF0KICBdCn0=",
    "signature": "6RYLgD/Hj7dDFPWU7ETOuI2IgqE=",
    "s3url": "https://cdn-twistbio.s3.amazonaws.com/"
});

(function() {
    'use strict';

    angular
        .module('app')
        .constant('REDIRECT', {
            LOGIN:      'login',
            SIGNUP:     'signup',
            ADMIN:      'admin-home',
        })
        .factory('API', (function(ENV_VARS) {

            // controlled from /config/app.env-vars.json file
            var base = ENV_VARS.apiUrl;

            return {
                ACCOUNTS:           base + 'api/accounts',
                ADMIN_GROUPS:       base + 'api/admin-groups',
                ADMINS:             base + 'api/admins',
                AUTH_ATTEMPTS:      base + 'api/auth-attempts',
                CATEGORIES:         base + 'api/categories',
                CONTACT:            base + 'api/contact',
                BLOG:               base + 'api/blog',
                EVENTS:             base + 'api/events',
                HIGHLIGHTS:         base + 'api/highlights',
                LOGIN:              base + 'api/login',
                LOGIN_FORGOT:       base + 'api/login/forgot',
                LOGIN_RESET:        base + 'api/login/reset',
                LOGOUT:             base + 'api/logout',
                NEWS:               base + 'api/news',
                PRESS:              base + 'api/press',
                SESSIONS:           base + 'api/sessions',
                SIGNUP:             base + 'api/signup',
                SIGNUP_INVITATION:  base + 'api/signup/invitation',
                LEADERSHIP:         base + 'api/leadership',
                TEAM:               base + 'api/team',
                USERS:              base + 'api/users',
                USERS_MY:           base + 'api/users/my',
                USERS_MY_PASSWORD:  base + 'api/users/my/password',

            }
        }))

})();

/**
 * Twist - Custom scripts
 */

angular.element(document).ready(function($timeout) {

    // Full height of sidebar
    function fix_height() {
        var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
        angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

        var navbarHeigh = angular.element('nav.navbar-default').height();
        var wrapperHeigh = angular.element('#page-wrapper').height();

        if (navbarHeigh > wrapperHeigh) {
            angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
        }

        if (navbarHeigh < wrapperHeigh) {
            angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
        }

        if (angular.element('body').hasClass('fixed-nav')) {
            if (navbarHeigh > wrapperHeigh) {
                angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
            }
            else {
                angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
            }
        }

    }

    angular.element(window).bind("load resize scroll", function() {
        if (!angular.element("body").hasClass('body-small')) {
            fix_height();
        }
    });

    // Move right sidebar top after scroll
    angular.element(window).scroll(function() {
        if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
            angular.element('#right-sidebar').addClass('sidebar-top');
        }
        else {
            angular.element('#right-sidebar').removeClass('sidebar-top');
        }
    });

    $timeout(function() {
        fix_height();
    });


    // Minimalize menu when screen is less than 768px
    angular.element(window).bind("load resize", function() {
        if (angular.element(document).width() < 769) {
            angular.element('body').addClass('body-small')
        }
        else {
            angular.element('body').removeClass('body-small')
        }
    })

});

(function() {
    'use strict';

    angular
        .module('app')
        .config(config);

    function config($logProvider, $locationProvider, $httpProvider, NotificationProvider, $modalProvider, $provide, ENV_VARS) {

        // LOGGING (turn on/off globally)
        if (ENV_VARS.debug=="true") {
            $logProvider.debugEnabled(true);
        }
        else {
            $logProvider.debugEnabled(false);
        }

        // CLEAN URLS
        $locationProvider.hashPrefix('!');
        $locationProvider.html5Mode({ enabled: true, requireBase: false });

        // AUTH INTERCEPTOR SERVICE (SNIFF FOR 401s)
        $httpProvider.interceptors.push('authInterceptorService');

        // UI-NOTIFICATION
        NotificationProvider.setOptions({
            startTop: 15,
            startRight: 20
        });

        // ANGULAR STRAP MODAL DEFAULTS
        angular.extend($modalProvider.defaults, {
            html: true
        });

    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/404.view.html","<div class=\"middle-box frontforms\" id=\"notfound\"><p class=\"heading\">Page Not Found</p><p class=\"lead\">The resource you requested doesn\'t exist.</p></div>");
$templateCache.put("app/admin/admin-404.view.html","<div class=\"middle-box frontforms\" id=\"notfound\"><p class=\"heading\">Page Not Found</p><p class=\"lead\">The resource you requested doesn\'t exist.</p></div>");
$templateCache.put("app/admin/admin-breadcrumb.view.html","<div class=\"breadcrumb-wrapper\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"page-title\"><div ncy-breadcrumb=\"\"></div></div></div></div></div>");
$templateCache.put("app/admin/admin-footer.view.html","<div class=\"footer\"><div class=\"pull-right\"><strong>Copyright</strong> Twist &copy; 2016</div></div>");
$templateCache.put("app/admin/admin-header.view.html","<div class=\"border-bottom\"><nav class=\"navbar navbar-static-top top-navigation\" role=\"navigation\" style=\"margin-bottom: 0;\"><div class=\"items-left\"></div><ul class=\"nav navbar-top-links navbar-right\"><li class=\"dropdown-group\" uib-dropdown=\"\"><a class=\"dropdown-toggle btn-user\" href=\"#\" uib-dropdown-toggle=\"\"><img src=\"/assets/images/user.png\" alt=\"\" class=\"img-circle\"> {{ username }} <span class=\"caret\"></span></a><ul class=\"uib-dropdown-menu dropdown-menu\" role=\"menu\"><li><a href=\"#\" ng-click=\"vm.logout()\"><i class=\"material-icons\">exit_to_app</i> Log Out</a></li></ul></li></ul></nav></div>");
$templateCache.put("app/admin/admin-home.view.html","<div class=\"middle-box frontforms\"><p class=\"heading\">Hello</p><p class=\"lead\">Welcome to Twist Admin.</p></div>");
$templateCache.put("app/admin/admin-sidebar.view.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"sidebar-header\"><img ui-sref=\"admin-home\" class=\"logo-mark\" src=\"/assets/images/tlogo-dark.svg\" alt=\"\"></div></li><br><li class=\"sidebar-label\">Content</li><li ng-if=\"isAuthorized(\'admin\')\" ng-class=\"{active: isActive(\'admin.account\')}\"><a ui-sref=\"admin.account\"><span class=\"nav-icon\"><i class=\"material-icons accounts-icon\">supervisor_account</i></span> <span class=\"nav-label\">Accounts</span></a></li><li ng-class=\"{active: isActive(\'admin.category\')}\"><a ui-sref=\"admin.category\"><span class=\"nav-icon\"><i class=\"material-icons\">label_outline</i></span> <span class=\"nav-label\">Blog Categories</span></a></li><li ng-class=\"{active: isActive(\'admin.blogPost\')}\"><a ui-sref=\"admin.blogPost\"><span class=\"nav-icon\"><i class=\"material-icons\">comment</i></span> <span class=\"nav-label\">Blog Posts</span></a></li><li ng-class=\"{active: isActive(\'admin.event\')}\"><a ui-sref=\"admin.event\"><span class=\"nav-icon\"><i class=\"material-icons\">date_range</i></span> <span class=\"nav-label\">Events</span></a></li><li ng-class=\"{active: isActive(\'admin.newsItem\')}\"><a ui-sref=\"admin.newsItem\"><span class=\"nav-icon\"><i class=\"material-icons\">reorder</i></span> <span class=\"nav-label\">News Items</span></a></li><li ng-class=\"{active: isActive(\'admin.pressRelease\')}\"><a ui-sref=\"admin.pressRelease\"><span class=\"nav-icon\"><i class=\"material-icons\">announcement</i></span> <span class=\"nav-label\">Press Releases</span></a></li><li ng-class=\"{active: isActive(\'admin.leadership\')}\"><a ui-sref=\"admin.leadership\"><span class=\"nav-icon\"><i class=\"material-icons accounts-icon\">supervisor_account</i></span> <span class=\"nav-label\">Leadership</span></a></li><li ng-class=\"{active: isActive(\'admin.teamMember\')}\"><a ui-sref=\"admin.teamMember\"><span class=\"nav-icon\"><i class=\"material-icons accounts-icon\">accessibility</i></span> <span class=\"nav-label\">Team Members</span></a></li><br><br></ul></div><div class=\"nav-footer\"><span minimaliza-sidebar=\"\"></span></div></nav>");
$templateCache.put("app/admin/admin.view.html","<div id=\"wrapper\"><div ng-include=\"\'app/admin/admin-sidebar.view.html\'\"></div><div id=\"page-wrapper\" class=\"white-bg {{$state.current.name}}\"><div ng-include=\"\'app/admin/admin-header.view.html\'\"></div><div ng-include=\"\'app/admin/admin-breadcrumb.view.html\'\"></div><div ui-view=\"\"><div ng-include=\"\'app/admin/admin-home.view.html\'\"></div></div></div></div>");
$templateCache.put("app/login/login.view.html","<div class=\"middle-box frontforms\" id=\"login\"><div class=\"page-header\"><img class=\"logo\" src=\"/assets/images/twist-logo_slate.svg\" alt=\"\"></div><form class=\"m-t\" role=\"form\" name=\"loginForm\" novalidate=\"\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': hasError(loginForm.username)}\"><input type=\"text\" placeholder=\"Username or Email\" name=\"username\" id=\"username\" class=\"form-control\" ng-model=\"vm.user.username\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(loginForm.username, \'required\')\">This field is required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': hasError(loginForm.password)}\"><input type=\"password\" placeholder=\"Password\" name=\"password\" id=\"password\" class=\"form-control\" ng-model=\"vm.user.password\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(loginForm.password, \'required\')\">This field is required</span></div><div class=\"form-actions\"><button type=\"submit\" class=\"btn btn-primary pull-left\" ng-disabled=\"!canSave(loginForm)\" ng-click=\"vm.login()\">Log In</button><div class=\"forgotpw-link\"><a ui-sref=\"forgotpw\">Forgot password?</a></div></div></form><div class=\"loadingdata\"><div ng-if=\"isDataLoading\"><div class=\"loadingimage\"></div></div></div></div>");
$templateCache.put("app/signup/signup.view.html","<div class=\"middle-box frontforms\" id=\"signup\"><div class=\"page-header\"><h1>Sign Up</h1></div><div class=\"\" ng-if=\"!vm.invitationToken\"><span>A valid invitation is required to join Ella.</span></div><form ng-if=\"vm.invitationToken\" class=\"m-t\" role=\"form\" name=\"signupForm\" novalidate=\"\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': hasError(signupForm.username)}\"><input type=\"text\" name=\"username\" id=\"username\" class=\"form-control\" placeholder=\"Pick a Username\" ng-model=\"vm.user.username\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(signupForm.username, \'required\')\">This field is required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': hasError(signupForm.email)}\"><input type=\"email\" name=\"email\" id=\"email\" class=\"form-control\" placeholder=\"Enter Your Email\" ng-model=\"vm.user.email\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(signupForm.email, \'required\')\">This field is required</span> <span class=\"help-block\" ng-show=\"showError(signupForm.email, \'email\')\">Please enter a valid email</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': hasError(signupForm.password)}\"><input type=\"password\" name=\"password\" id=\"password\" class=\"form-control\" placeholder=\"Create a Password\" ng-model=\"vm.user.password\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(signupForm.password, \'required\')\">This field is required</span></div><div class=\"form-actions\"><button type=\"submit\" class=\"btn btn-primary pull-left\" ng-disabled=\"!canSave(signupForm)\" ng-click=\"vm.signup()\">Sign Up</button></div></form><div class=\"loadingdata\"><div ng-if=\"isDataLoading\"><div class=\"loadingimage\"></div></div></div></div>");
$templateCache.put("app/login/forgot/login-forgot.view.html","<div class=\"middle-box frontforms\" id=\"forgot\"><div class=\"page-header\"><img class=\"logo\" src=\"/assets/images/twist-logo_slate.svg\" alt=\"\"></div><form class=\"m-t\" role=\"form\" name=\"loginForgotForm\" novalidate=\"\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': hasError(loginForgotForm.email)}\"><input type=\"email\" name=\"email\" id=\"email\" placeholder=\"Enter Your Email\" class=\"form-control\" ng-model=\"vm.email\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(loginForgotForm.email, \'required\')\">This field is required</span> <span class=\"help-block\" ng-show=\"showError(loginForgotForm.email, \'email\')\">Please enter a valid email</span></div><div class=\"form-actions\"><button type=\"submit\" class=\"btn btn-primary pull-left\" ng-disabled=\"!canSave(loginForgotForm)\" ng-click=\"vm.forgot()\">Forgot Password</button><div class=\"backtologin-link\"><a ui-sref=\"login\">Back to Login</a></div></div></form><div class=\"loadingdata\"><div ng-if=\"isDataLoading\"><div class=\"loadingimage\"></div></div></div></div>");
$templateCache.put("app/login/modal/login-modal.view.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" id=\"login\"><div class=\"modal-dialog\"><div class=\"modal-content\"><form class=\"\" role=\"form\" name=\"loginForm\" novalidate=\"\"><div class=\"modal-body\"><div class=\"page-header\"><h1>Log In</h1></div><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : loginForm.username.$invalid && !loginForm.username.$pristine }\"><input type=\"text\" placeholder=\"Username or Email\" name=\"username\" id=\"username\" class=\"form-control\" ng-model=\"vm.user.username\" required=\"\"> <span class=\"help-block\" ng-show=\"loginForm.username.$invalid && !loginForm.username.$pristine\">This field is required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\' : loginForm.password.$invalid && !loginForm.password.$pristine }\"><input type=\"password\" placeholder=\"Password\" name=\"password\" id=\"password\" class=\"form-control\" ng-model=\"vm.user.password\" required=\"\"> <span class=\"help-block\" ng-show=\"loginForm.password.$invalid && !loginForm.password.$pristine\" \"=\"\">This field is required</span></div><div class=\"form-actions\"><button type=\"submit\" class=\"btn btn-primary pull-left\" ng-disabled=\"loginForm.$invalid\" ng-click=\"vm.modalLogin()\">Log In</button> &nbsp; <button class=\"btn btn-warning\" ng-click=\"vm.closeLoginModal()\">Cancel</button></div></div></form></div></div></div>");
$templateCache.put("app/login/reset/login-reset.view.html","<div class=\"middle-box frontforms\" id=\"reset\"><div class=\"page-header\"><h1>Reset Your Password?</h1></div><form class=\"m-t\" role=\"form\" name=\"resetForm\" novalidate=\"\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group\" ng-if=\"vm.valid\"><input type=\"password\" name=\"password\" ng-model=\"vm.password\" class=\"form-control input-lg\" placeholder=\"Create a Password (required)\" ng-minlength=\"5\" required=\"\"><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(resetForm.password)}\"><span class=\"help-block\" ng-show=\"showError(resetForm.password, \'required\')\">Please input your password</span> <span class=\"help-block\" ng-show=\"showError(resetForm.password, \'minlength\')\">The password needs to be at least 5 characters</span></div><input type=\"password\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" class=\"form-control input-lg\" placeholder=\"Confirm Password\" ng-minlength=\"5\" ui-validate-async=\"{notMatch: \'vm.isPasswordConfirmed($value)\'}\" required=\"\"><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(resetForm.confirmPassword)}\"><span class=\"help-block\" ng-show=\"showError(resetForm.confirmPassword, \'required\')\">Please comfirm your password</span> <span class=\"help-block\" ng-show=\"showError(resetForm.confirmPassword, \'notMatch\')\">Password and confirmation do not match</span></div></div><div class=\"form-actions\"><button type=\"submit\" class=\"btn btn-primary btn-reset pull-left\" ng-if=\"vm.valid\" ng-disabled=\"!canSave(resetForm)\" ng-click=\"vm.resetPassword()\">Set Password</button><div class=\"backtologin-link\"><a ui-sref=\"login\">Back to Login</a></div></div></form><div class=\"loadingdata\"><div ng-if=\"isDataLoading\"><div class=\"loadingimage\"></div></div></div></div>");
$templateCache.put("app/admin/sections/account/account.view.html","<div class=\"wrapper wrapper-content\"><title>Accounts</title><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row filters\"><div class=\"col-sm-6 account-loading\"><span ng-show=\"vm.isTableLoading\">Loading...</span></div><div ng-if=\"isAdmin()\" class=\"col-sm-6 addloc\"><button type=\"button\" class=\"btn btn-add btn-primary\" ui-sref=\"account-add\">Add</button></div></div><div class=\"table-responsive\" style=\"margin-top: 15px;\"><table st-pipe=\"vm.getAccounts\" st-table=\"vm.accounts\" class=\"table table-striped\"><thead><tr><th st-sort=\"name.first\" data-type=\"alpha\">Full Name</th><th st-sort=\"user.name\">Username</th><th>Email</th><th st-sort=\"timeCreated\">Created</th></tr></thead><tbody ng-show=\"!vm.isTableLoading\"><tr class=\"list-name\" ng-repeat=\"account in vm.accounts\" ui-sref=\"account-edit({id: account._id})\"><td class=\"admin-name\">{{account.name.first}} {{account.name.last}}</td><td class=\"admin-name\">{{account.user.name}}</td><td class=\"admin-name\"><user-email id=\"{{account.user.id}}\"></user-email></td><td>{{ account.timeCreated | formatTime:true }}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"1\" colspan=\"3\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/admin/sections/blog-post/blog-post.view.html","<div class=\"wrapper wrapper-content\"><title>Blog Posts</title><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row filters\"><div class=\"col-sm-6 loading-text\"><span ng-show=\"vm.isTableLoading\">Loading...</span></div><div class=\"col-sm-6 addloc\"><button type=\"button\" class=\"btn btn-add btn-primary\" ui-sref=\"blogPost-add\">Add</button></div></div><div class=\"table-responsive\" style=\"margin-top: 15px;\"><table st-pipe=\"vm.getBlogPosts\" st-table=\"vm.blogPosts\" class=\"table table-striped\"><thead><tr><th st-sort=\"event.header\">Header Image</th><th st-sort=\"blogPost.title\">Title</th><th st-sort=\"blogPost.created\">Created</th></tr></thead><tbody ng-show=\"!vm.isTableLoading\"><tr class=\"list-name\" ng-repeat=\"blogPost in vm.blogPosts\" ui-sref=\"blogPost-edit({id: blogPost._id})\"><td class=\"admin-name\"><img class=\"img-responsive table-image\" ng-src=\"{{blogPost.headerUrl}}\"></td><td class=\"admin-name\">{{blogPost.title}}</td><td>{{ blogPost.created | formatTime:true }}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"1\" colspan=\"3\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/admin/sections/category/category.view.html","<div class=\"wrapper wrapper-content\"><title>Blog Categories</title><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row filters\"><div class=\"col-sm-6 loading-text\"><span ng-show=\"vm.isTableLoading\">Loading...</span></div><div class=\"col-sm-6 addloc\"><button type=\"button\" class=\"btn btn-add btn-primary\" ui-sref=\"category-add\">Add</button></div></div><div class=\"table-responsive\" style=\"margin-top: 15px;\"><table st-pipe=\"vm.getCategories\" st-table=\"vm.categories\" class=\"table table-striped\"><thead><tr><th st-sort=\"category.name\">Name</th><th st-sort=\"category.timeCreated\">Created</th></tr></thead><tbody ng-show=\"!vm.isTableLoading\"><tr class=\"list-name\" ng-repeat=\"category in vm.categories\" ui-sref=\"category-edit({id: category._id})\"><td class=\"admin-name\">{{category.name}}</td><td>{{ category.timeCreated | formatTime:true }}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"1\" colspan=\"3\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/admin/sections/event/event.view.html","<div class=\"wrapper wrapper-content\"><title>Events</title><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row filters\"><div class=\"col-sm-6 loading-text\"><span ng-show=\"vm.isTableLoading\">Loading...</span></div><div class=\"col-sm-6 addloc\"><button type=\"button\" class=\"btn btn-add btn-primary\" ui-sref=\"event-add\">Add</button></div></div><div class=\"table-responsive\" style=\"margin-top: 15px;\"><table st-pipe=\"vm.getEvents\" st-table=\"vm.events\" class=\"table table-striped\"><thead><tr><th st-sort=\"event.image\">Image</th><th st-sort=\"event.title\">Title</th><th st-sort=\"event.url\">URL</th><th st-sort=\"event.startDate\">Start Date</th><th st-sort=\"event.endDate\">End Date</th><th st-sort=\"event.location\">Location</th></tr></thead><tbody ng-show=\"!vm.isTableLoading\"><tr class=\"list-name\" ng-repeat=\"event in vm.events\" ui-sref=\"event-edit({id: event._id})\"><td class=\"admin-name\"><img class=\"img-responsive table-image\" ng-src=\"{{event.thumbnailUrl}}\"></td><td class=\"admin-name\">{{event.title}}</td><td class=\"admin-name\"><a href=\"{{event.url}}\">{{event.url}}</a></td><td>{{ event.startDate | formatTime:true }}</td><td>{{ event.endDate | formatTime:true }}</td><td>{{ event.location }}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"1\" colspan=\"3\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/admin/sections/leadership/leadership.view.html","<div class=\"wrapper wrapper-content\"><title>Leadership</title><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row filters\"><div class=\"col-sm-6 loading-text\"><span ng-show=\"vm.isTableLoading\">Loading...</span></div><div class=\"col-sm-6 addloc\"><button type=\"button\" class=\"btn btn-add btn-primary\" ui-sref=\"leadership-add\">Add</button></div></div><div class=\"table-responsive\" style=\"margin-top: 15px;\"><table st-pipe=\"vm.getLeaderships\" st-table=\"vm.leaderships\" class=\"table table-striped\"><thead><tr><th st-sort=\"leadership.image\">Image</th><th st-sort=\"leadership.name\">Name</th><th st-sort=\"leadership.position\">Position</th><th st-sort=\"leadership.created\">Created</th></tr></thead><tbody ng-show=\"!vm.isTableLoading\"><tr class=\"list-name\" ng-repeat=\"leadership in vm.leaderships\" ui-sref=\"leadership-edit({id: leadership._id})\"><td class=\"admin-name\"><img class=\"img-responsive table-image\" ng-src=\"{{leadership.imageUrl}}\"></td><td class=\"admin-name\">{{leadership.name}}</td><td>{{ leadership.position }}</td><td>{{ leadership.created | formatTime:true }}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"1\" colspan=\"3\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/admin/sections/news-item/news-item.view.html","<div class=\"wrapper wrapper-content\"><title>News Items</title><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row filters\"><div class=\"col-sm-6 loading-text\"><span ng-show=\"vm.isTableLoading\">Loading...</span></div><div class=\"col-sm-6 addloc\"><button type=\"button\" class=\"btn btn-add btn-primary\" ui-sref=\"newsItem-add\">Add</button></div></div><div class=\"table-responsive\" style=\"margin-top: 15px;\"><table st-pipe=\"vm.getNewsItems\" st-table=\"vm.newsItems\" class=\"table table-striped\"><thead><tr><th st-sort=\"newsItem.image\">Image</th><th st-sort=\"newsItem.title\">Title</th><th st-sort=\"newsItem.url\">URL</th><th st-sort=\"newsItem.date\">Date</th></tr></thead><tbody ng-show=\"!vm.isTableLoading\"><tr class=\"list-name\" ng-repeat=\"newsItem in vm.newsItems\" ui-sref=\"newsItem-edit({id: newsItem._id})\"><td class=\"admin-name\"><img class=\"img-responsive table-image\" ng-src=\"{{newsItem.thumbnailUrl}}\"></td><td class=\"admin-name\">{{newsItem.title}}</td><td class=\"admin-name\"><a href=\"{{newsItem.url}}\">{{newsItem.url}}</a></td><td>{{ newsItem.date | formatTime:true }}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"1\" colspan=\"3\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/admin/sections/press-release/press-release.view.html","<div class=\"wrapper wrapper-content\"><title>Press Releases</title><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row filters\"><div class=\"col-sm-6 loading-text\"><span ng-show=\"vm.isTableLoading\">Loading...</span></div><div class=\"col-sm-6 addloc\"><button type=\"button\" class=\"btn btn-add btn-primary\" ui-sref=\"pressRelease-add\">Add</button></div></div><div class=\"table-responsive\" style=\"margin-top: 15px;\"><table st-pipe=\"vm.getPressReleases\" st-table=\"vm.pressReleases\" class=\"table table-striped\"><thead><tr><th st-sort=\"pressRelease.title\">Title</th><th st-sort=\"pressRelease.date\">Date</th></tr></thead><tbody ng-show=\"!vm.isTableLoading\"><tr class=\"list-name\" ng-repeat=\"pressRelease in vm.pressReleases\" ui-sref=\"pressRelease-edit({id: pressRelease._id})\"><td class=\"admin-name\">{{pressRelease.title}}</td><td>{{ pressRelease.date | formatTime:true }}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"1\" colspan=\"3\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/admin/sections/team-member/team-member.view.html","<div class=\"wrapper wrapper-content\"><title>Team Member</title><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row filters\"><div class=\"col-sm-6 loading-text\"><span ng-show=\"vm.isTableLoading\">Loading...</span></div><div class=\"col-sm-6 addloc\"><button type=\"button\" class=\"btn btn-add btn-primary\" ui-sref=\"teamMember-add\">Add</button></div></div><div class=\"table-responsive\" style=\"margin-top: 15px;\"><table st-pipe=\"vm.getTeamMembers\" st-table=\"vm.teamMembers\" class=\"table table-striped\"><thead><tr><th st-sort=\"teamMember.image\">Image</th><th st-sort=\"teamMember.name\">Name</th><th st-sort=\"teamMember.created\">Created</th></tr></thead><tbody ng-show=\"!vm.isTableLoading\"><tr class=\"list-name\" ng-repeat=\"teamMember in vm.teamMembers\" ui-sref=\"teamMember-edit({id: teamMember._id})\"><td class=\"admin-name\"><img class=\"img-responsive table-image\" ng-src=\"{{teamMember.imageUrl}}\"></td><td class=\"admin-name\">{{teamMember.name}}</td><td>{{ teamMember.created | formatTime:true }}</td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"1\" colspan=\"3\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/admin/sections/account/account-add/account-add.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>Add Account</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"accountAddForm\" novalidate=\"\"><div class=\"aside-body\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"fields\">Account Information</label><p>Complete the fields provided to add the account. All fields are required.</p><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(accountAddForm.name)}\"><input type=\"text\" name=\"name\" id=\"name\" class=\"form-control input-lg\" placeholder=\"First and Last Name\" ng-model=\"vm.user.name\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(accountAddForm.name, \'required\')\">This field is required</span></div></div></div></div><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(accountAddForm)\" ng-click=\"vm.addAccount()\">Add</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button></div></form></div></div></div>");
$templateCache.put("app/admin/sections/account/account-edit/account-edit.view.html","<div class=\"aside admin view\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>Account:&nbsp;&nbsp;<b>{{vm.account.first | capitalize}} {{vm.account.last | capitalize}}</b></h2></div></section></div><div class=\"aside-body\"><uib-tabset active=\"active\"><uib-tab index=\"0\"><uib-tab-heading>Details</uib-tab-heading><form class=\"form edit\" role=\"form\" name=\"accountDetailsForm\" novalidate=\"\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group\"><div ng-if=\"!vm.inviteSent\"><label class=\"m-t\">Invite to Twist CMS</label><div class=\"row\"><div class=\"col-sm-8\"><input type=\"email\" name=\"inv_email\" id=\"inv_email\" class=\"form-control input-lg\" placeholder=\"Email address\" ng-model=\"vm.inviteEmail\"></div><div class=\"col-sm-4\"><button type=\"submit\" class=\"btn btn-primary input-lg\" ng-disabled=\"vm.inviteWasClicked || vm.inviteEmail.length < 4\" ng-click=\"vm.inviteClicked();vm.inviteWasClicked=true;\">Invite</button></div></div></div><label class=\"m-t\">Account Details</label><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(accountDetailsForm.firstname)}\"><input type=\"text\" name=\"firstname\" id=\"firstname\" class=\"form-control input-lg\" placeholder=\"First Name\" ng-model=\"vm.account.first\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(accountDetailsForm.firstname, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(accountDetailsForm.lastname)}\"><input type=\"text\" name=\"lastname\" id=\"lastname\" class=\"form-control input-lg\" placeholder=\"Last Name\" ng-model=\"vm.account.last\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(accountDetailsForm.lastname, \'required\')\">This field is required</span></div></div><div class=\"form-group\"><div>Account Created: {{ vm.account.timeCreated | formatTime:true }}</div></div></div></form><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(accountDetailsForm)\" ng-click=\"vm.updateAccountDetails()\">Update</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button> <button ng-click=\"vm.deleteAccount()\" class=\"btn btn-danger m-l-xl\">Delete</button></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/admin/sections/blog-post/blog-post-add-edit/blog-post-add-edit.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>{{vm.editing == true ? \'Edit\' : \'Add\'}} Blog Post</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"blogPostAddEditForm\" novalidate=\"\"><uib-tabset active=\"active\" class=\"aside-tabs\"><uib-tab index=\"0\"><uib-tab-heading>Details</uib-tab-heading><div class=\"aside-body aside-body--tab\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"title\">Blog Post Details</label><div ng-class=\"{\'has-error\': hasError(blogPostAddEditForm.title)}\"><input type=\"text\" name=\"title\" id=\"title\" class=\"form-control input-lg\" placeholder=\"Title\" ng-model=\"vm.blogPost.title\" maxlength=\"140\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(blogPostAddEditForm.title, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(blogPostAddEditForm.author)}\"><input type=\"text\" name=\"author\" id=\"author\" class=\"form-control input-lg\" placeholder=\"Author\" ng-model=\"vm.blogPost.author\"></div></div><div class=\"form-group\"><div class=\"m-t\"><label>Category</label><category-multi-select selected-category-ids=\"vm.categoryIds\"></category-multi-select><div class=\"m-t-xs\" ng-show=\"blogPostAddEditForm.categoryId.$invalid && blogPostAddEditForm.submitted\"><small class=\"text-danger\" ng-show=\"blogPostAddEditForm.categoryId.$error.required\">Please select a category</small></div></div></div><div class=\"form-group\"><div class=\"m-t\"><label for=\"title\">Header Image</label><div ng-if=\"vm.blogPost.headerUrl\"><input disabled=\"\" type=\"text\" name=\"headerUrl\" id=\"headerUrl\" class=\"form-control input-lg\" placeholder=\"Header URL\" ng-model=\"vm.blogPost.headerUrl\"> <img class=\"m-t img-responsive\" ng-src=\"{{vm.blogPost.headerUrl}}\"> <button class=\"m-t btn btn-danger\" ng-click=\"vm.blogPost.headerUrl = null;\">Remove</button></div><input ng-if=\"!vm.blogPost.headerUrl\" class=\"m-t\" type=\"file\" ngf-select=\"\" ng-model=\"vm.headerFile\" name=\"headerFile\" accept=\"image/*\" ngf-max-size=\"3MB\" required=\"\" ngf-model-invalid=\"errorFile\"> <span class=\"m-t help-block\" ng-show=\"!vm.headerFile && !vm.blogPost.headerUrl\">A header image is required - Max file upload size is 3MB</span><div class=\"m-t-lg\" ng-if=\"vm.progress && vm.progress > 0\"><label>Upload Progress:</label><uib-progressbar class=\"m-t-xs\" value=\"vm.progress\"></uib-progressbar></div></div></div><div class=\"form-group\"><div class=\"m-t\"><label>Body</label><trix-editor angular-trix=\"\" ng-if=\"true\" name=\"body\" id=\"body\" class=\"txt-editor\" placeholder=\"Write something...\" required=\"\" trix-attachment-add=\"vm.trixAttachmentAdd(e, editor);\" ng-model=\"vm.blogPost.body\"></trix-editor><span class=\"help-block\" ng-show=\"showError(blogPostAddEditForm.body, \'required\')\">This field is required</span></div></div><div class=\"form-group\"><div class=\"m-t\" ng-class=\"{\'has-error\': !vm.isTimeValid() }\"><label>Schedule for Posting</label><div class=\"row schedule-container\"><div class=\"col-md-6\"><input bs-datepicker=\"\" type=\"text\" name=\"releaseDate\" id=\"date\" class=\"form-control input-lg\" min-date=\"today\" placeholder=\"Release Date\" ng-model=\"vm.blogPost.releaseDate\" data-arrow-behavior=\"picker\" data-autoclose=\"1\"></div><div class=\"col-md-6\" ng-if=\"vm.blogPost.releaseDate\"><input type=\"text\" size=\"8\" class=\"form-control input-lg\" ng-model=\"vm.blogPost.releaseDate\" data-time-format=\"h:mm a\" data-autoclose=\"1\" placeholder=\"Release Time\" data-minute-step=\"5\" data-round-display=\"true\" bs-timepicker=\"\"></div><div class=\"col-xs-12\"><span class=\"help-block\" ng-show=\"!vm.isTimeValid()\">The Release Date is invalid (must be at least {{ vm.getCurrentDate() | formatTime: true }})</span></div></div></div></div></div><div class=\"clearfix\"></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading>SEO Settings</uib-tab-heading><div class=\"aside-body aside-body--tab\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"title\">General</label><div ng-class=\"{\'has-error\': hasError(blogPostAddEditForm.metaTitle)}\"><input type=\"text\" name=\"metaTitle\" id=\"metaTitle\" class=\"form-control input-lg\" placeholder=\"Title\" ng-model=\"vm.blogPost.metaTitle\" maxlength=\"65\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(blogPostAddEditForm.metaTitle, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(blogPostAddEditForm.metaSlug)}\"><input type=\"text\" name=\"metaSlug\" id=\"metaSlug\" class=\"form-control input-lg\" placeholder=\"Slug\" ng-model=\"vm.blogPost.metaSlug\" maxlength=\"150\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(blogPostAddEditForm.metaSlug, \'required\')\">This field is required</span></div><div class=\"m-t\"><textarea name=\"metaDescription\" maxlength=\"165\" ng-model=\"vm.blogPost.metaDescription\" id=\"metaDescription\" class=\"form-control input-lg\" placeholder=\"Description\">\n                                        </textarea></div></div></div><div class=\"clearfix\"></div></div></uib-tab></uib-tabset><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(blogPostAddEditForm)\" ng-click=\"vm.saveBlogPost()\">{{vm.editing == true ? \'Update\' : \'Add\'}}</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button> <button ng-if=\"vm.editing == true\" type=\"submit\" class=\"btn btn-danger\" ng-click=\"vm.deleteBlogPost()\">Delete</button></div></form></div></div></div>");
$templateCache.put("app/admin/sections/category/category-add/category-add.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>Add Blog Category</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"categoryAddForm\" novalidate=\"\"><div class=\"aside-body\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"fields\">Category Information</label><p>Complete the fields provided to add the category. All fields are required.</p><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(categoryAddForm.name)}\"><input type=\"text\" name=\"name\" id=\"name\" class=\"form-control input-lg\" placeholder=\"Category Name\" ng-model=\"vm.category.name\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(categoryAddForm.name, \'required\')\">This field is required</span></div></div></div></div><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(categoryAddForm)\" ng-click=\"vm.addCategory()\">Add</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button></div></form></div></div></div>");
$templateCache.put("app/admin/sections/category/category-edit/category-edit.view.html","<div class=\"aside admin view notabs\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>Blog Category:&nbsp;&nbsp;<b>{{vm.category.name | capitalize}}</b></h2></div></section></div><form class=\"form edit\" role=\"form\" name=\"categoryEditForm\" novalidate=\"\"><div class=\"aside-body\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group\"><label for=\"fields\">Category Details</label><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(categoryEditForm.name)}\"><input type=\"text\" name=\"name\" ng-class=\"{\'has-error\': hasError(categoryEditForm.name)}\" id=\"name\" class=\"form-control input-lg\" placeholder=\"Category Name\" ng-model=\"vm.category.name\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(categoryEditForm.name, \'required\')\">This field is required</span></div></div><div class=\"form-group\"><div>Category Created: {{ vm.category.timeCreated | formatTime:true }}</div></div></div></div></form><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(categoryEditForm)\" ng-click=\"vm.updateCategory()\">Update</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button></div></div></div></div>");
$templateCache.put("app/admin/sections/event/event-add-edit/event-add-edit.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>{{vm.editing == true ? \'Edit\' : \'Add\'}} Event</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"eventAddEditForm\" novalidate=\"\"><div class=\"aside-body\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"title\">Event Details</label><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(eventAddEditForm.title)}\"><input type=\"text\" name=\"title\" id=\"title\" class=\"form-control input-lg\" placeholder=\"Title\" ng-model=\"vm.event.title\" maxlength=\"140\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(eventAddEditForm.title, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(eventAddEditForm.location)}\"><input type=\"text\" name=\"location\" id=\"location\" class=\"form-control input-lg\" placeholder=\"Location\" ng-model=\"vm.event.location\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(eventAddEditForm.location, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(eventAddEditForm.url)}\"><div class=\"input-group\"><input type=\"text\" name=\"url\" id=\"url\" class=\"form-control input-lg\" placeholder=\"URL\" ng-model=\"vm.event.url\" required=\"\"> <span class=\"input-group-btn\"><a target=\"_blank\" ng-href=\"{{vm.event.url}}\"><button class=\"m-l-sm btn btn-default input-lg\" type=\"button\" ng-click=\"\">Visit</button></a></span></div><span class=\"help-block\" ng-show=\"showError(eventAddEditForm.url, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(eventAddEditForm.startDate)}\"><input bs-datepicker=\"\" type=\"text\" name=\"startDate\" id=\"date\" class=\"form-control input-lg\" placeholder=\"Start Date\" ng-model=\"vm.event.startDate\" required=\"\" data-arrow-behavior=\"picker\" data-autoclose=\"1\"> <input type=\"text\" size=\"8\" class=\"form-control m-t input-lg\" ng-model=\"vm.event.startDate\" data-time-format=\"h:mm a\" data-autoclose=\"1\" placeholder=\"Start Time\" data-minute-step=\"15\" data-round-display=\"true\" bs-timepicker=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(eventAddEditForm.startDate, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(eventAddEditForm.endDate)}\"><input bs-datepicker=\"\" type=\"text\" name=\"endDate\" id=\"endDate\" class=\"form-control input-lg\" placeholder=\"End Date\" ng-model=\"vm.event.endDate\" required=\"\" data-arrow-behavior=\"picker\" data-autoclose=\"1\"> <input type=\"text\" size=\"8\" class=\"form-control m-t input-lg\" ng-model=\"vm.event.endDate\" data-time-format=\"h:mm a\" data-autoclose=\"0\" placeholder=\"End Time\" data-minute-step=\"15\" data-round-display=\"true\" bs-timepicker=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(eventAddEditForm.endDate, \'required\')\">This field is required</span></div></div><div class=\"form-group\"><div class=\"m-t\"><label for=\"title\">Event Image</label><div ng-if=\"vm.event.thumbnailUrl\"><input disabled=\"\" type=\"text\" name=\"thumbnailUrl\" id=\"thumbnailUrl\" class=\"form-control input-lg\" placeholder=\"Thumbnail URL\" ng-model=\"vm.event.thumbnailUrl\"> <img class=\"m-t img-responsive\" ng-src=\"{{vm.event.thumbnailUrl}}\"> <button class=\"m-t btn btn-danger\" ng-click=\"vm.event.thumbnailUrl = null;\">Remove</button></div><input ng-if=\"!vm.event.thumbnailUrl\" class=\"m-t\" type=\"file\" ngf-select=\"\" ng-model=\"vm.thumbnailFile\" name=\"thumbnailFile\" accept=\"image/*\" ngf-max-size=\"2MB\" required=\"\" ngf-model-invalid=\"errorFile\"><span class=\"m-t help-block\" ng-show=\"!vm.thumbnailFile && !vm.event.thumbnailUrl\">A thumbnail is required</span><div class=\"m-t-lg\" ng-if=\"vm.progress && vm.progress > 0\"><label>Upload Progress:</label><uib-progressbar class=\"m-t-xs\" value=\"vm.progress\"></uib-progressbar></div></div></div></div></div><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(eventAddEditForm)\" ng-click=\"vm.saveEvent()\">{{vm.editing == true ? \'Update\' : \'Add\'}}</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button> <button ng-if=\"vm.editing == true\" type=\"submit\" class=\"btn btn-danger\" ng-click=\"vm.deleteEvent()\">Delete</button></div></form></div></div></div>");
$templateCache.put("app/admin/sections/leadership/leadership-add-edit/leadership-add-edit.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>{{vm.editing == true ? \'Edit\' : \'Add\'}} Leadership</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"leadershipAddEditForm\" novalidate=\"\"><div class=\"aside-body\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"name\">Leadership Details</label><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(leadershipAddEditForm.name)}\"><input type=\"text\" name=\"name\" id=\"name\" class=\"form-control input-lg\" placeholder=\"Name\" ng-model=\"vm.leadership.name\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(leadershipAddEditForm.name, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(leadershipAddEditForm.position)}\"><input type=\"text\" name=\"position\" id=\"position\" class=\"form-control input-lg\" placeholder=\"Position\" ng-model=\"vm.leadership.position\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(leadershipAddEditForm.position, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(leadershipAddEditForm.order)}\"><input type=\"number\" min=\"1\" name=\"order\" id=\"order\" class=\"form-control input-lg\" placeholder=\"Order\" ng-model=\"vm.leadership.order\"> <span class=\"help-block\" ng-show=\"showError(leadershipAddEditForm.order, \'min\')\">The minimum order is \"1\"</span></div></div><div class=\"form-group\"><div class=\"m-t\"><label for=\"name\">Leadership Image</label><div ng-if=\"vm.leadership.imageUrl\"><input disabled=\"\" type=\"text\" name=\"imageUrl\" id=\"imageUrl\" class=\"form-control input-lg\" placeholder=\"Thumbnail URL\" ng-model=\"vm.leadership.imageUrl\"> <img class=\"m-t img-responsive\" ng-src=\"{{vm.leadership.imageUrl}}\"> <button class=\"m-t btn btn-danger\" ng-click=\"vm.leadership.imageUrl = null;\">Remove</button></div><input ng-if=\"!vm.leadership.imageUrl\" class=\"m-t\" type=\"file\" ngf-select=\"\" ng-model=\"vm.imageFile\" name=\"imageFile\" accept=\"image/*\" ngf-max-size=\"2MB\" required=\"\" ngf-model-invalid=\"errorFile\"> <span class=\"m-t help-block\" ng-show=\"!vm.imageFile && !vm.leadership.imageUrl\">A image is required</span><div class=\"m-t-lg\" ng-if=\"vm.progress && vm.progress > 0\"><label>Upload Progress:</label><uib-progressbar class=\"m-t-xs\" value=\"vm.progress\"></uib-progressbar></div></div></div><div class=\"form-group\"><div class=\"m-t\"><label>Bio</label><trix-editor class=\"txt-editor\" angular-trix=\"\" ng-model=\"vm.leadership.bio\"></trix-editor></div></div><div class=\"form-group\"><div class=\"m-t\"><label>Publications</label><trix-editor class=\"txt-editor\" angular-trix=\"\" ng-model=\"vm.leadership.publications\"></trix-editor></div></div></div><div class=\"clearfix\"></div></div><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(leadershipAddEditForm)\" ng-click=\"vm.saveLeadership()\">{{vm.editing == true ? \'Update\' : \'Add\'}}</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button> <button ng-if=\"vm.editing == true\" type=\"submit\" class=\"btn btn-danger\" ng-click=\"vm.deleteLeadership()\">Delete</button></div></form></div></div></div>");
$templateCache.put("app/admin/sections/news-item/news-item-add-edit/news-item-add-edit.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>{{vm.editing == true ? \'Edit\' : \'Add\'}} News Item</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"newsItemAddForm\" novalidate=\"\"><div class=\"aside-body\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"title\">News Item Details</label><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(newsItemAddForm.title)}\"><input type=\"text\" name=\"title\" id=\"title\" class=\"form-control input-lg\" placeholder=\"Title\" ng-model=\"vm.newsItem.title\" maxlength=\"140\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(newsItemAddForm.title, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(newsItemAddForm.url)}\"><div class=\"input-group\"><input type=\"text\" name=\"url\" id=\"url\" class=\"form-control input-lg\" placeholder=\"URL\" ng-model=\"vm.newsItem.url\" required=\"\"> <span class=\"input-group-btn\"><a target=\"_blank\" ng-href=\"{{vm.newsItem.url}}\"><button class=\"m-l-sm btn btn-default input-lg\" type=\"button\" ng-click=\"\">Visit</button></a></span></div><span class=\"help-block\" ng-show=\"showError(newsItemAddForm.url, \'required\')\">This field is required</span></div><div class=\"form-group\"><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(newsItemAddForm.date)}\"><input bs-datepicker=\"\" type=\"text\" name=\"date\" id=\"date\" class=\"form-control input-lg\" placeholder=\"Date\" ng-model=\"vm.newsItem.date\" required=\"\" data-arrow-behavior=\"picker\" data-autoclose=\"1\"> <span class=\"help-block\" ng-show=\"showError(newsItemAddForm.date, \'required\')\">This field is required</span></div></div><div class=\"form-group\"><div class=\"m-t\"><label for=\"title\">Thumbnail</label><div ng-if=\"vm.newsItem.thumbnailUrl\"><input disabled=\"\" type=\"text\" name=\"thumbnailUrl\" id=\"thumbnailUrl\" class=\"form-control input-lg\" placeholder=\"Thumbnail URL\" ng-model=\"vm.newsItem.thumbnailUrl\"> <img class=\"m-t img-responsive\" ng-src=\"{{vm.newsItem.thumbnailUrl}}\"> <button class=\"m-t btn btn-danger\" ng-click=\"vm.newsItem.thumbnailUrl = null;\">Remove</button></div><input ng-if=\"!vm.newsItem.thumbnailUrl\" class=\"m-t\" type=\"file\" ngf-select=\"\" ng-model=\"vm.thumbnailFile\" name=\"thumbnailFile\" accept=\"image/*\" ngf-max-size=\"2MB\" required=\"\" ngf-model-invalid=\"errorFile\"><span class=\"m-t help-block\" ng-show=\"!vm.thumbnailFile && !vm.newsItem.thumbnailUrl\">A thumbnail is required</span><div class=\"m-t-lg\" ng-if=\"vm.progress && vm.progress > 0\"><label>Upload Progress:</label><uib-progressbar class=\"m-t-xs\" value=\"vm.progress\"></uib-progressbar></div></div></div><div class=\"form-group\"><div ng-if=\"vm.editing\" class=\"m-t\"><highlight-select highlight=\"vm.highlight\"></highlight-select></div></div><div class=\"form-group\"><div class=\"m-t\" ng-class=\"{\'has-error\': !vm.isTimeValid() }\"><label>Schedule for Posting</label><div class=\"row schedule-container\"><div class=\"col-md-6\"><input bs-datepicker=\"\" type=\"text\" name=\"releaseDate\" id=\"date\" class=\"form-control input-lg\" min-date=\"today\" placeholder=\"Release Date\" ng-model=\"vm.newsItem.releaseDate\" data-arrow-behavior=\"picker\" data-autoclose=\"1\"></div><div class=\"col-md-6\" ng-if=\"vm.newsItem.releaseDate\"><input type=\"text\" size=\"8\" class=\"form-control input-lg\" ng-model=\"vm.newsItem.releaseDate\" data-time-format=\"h:mm a\" data-autoclose=\"1\" placeholder=\"Release Time\" data-minute-step=\"5\" data-round-display=\"true\" bs-timepicker=\"\"></div><div class=\"col-xs-12\"><span class=\"help-block\" ng-show=\"!vm.isTimeValid()\">The Release Date is invalid (must be at least {{ vm.getCurrentDate() | formatTime: true }})</span></div></div></div></div></div></div><div class=\"clearfix\"></div></div><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(newsItemAddForm)\" ng-click=\"vm.saveNewsItem()\">{{vm.editing == true ? \'Update\' : \'Add\'}}</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button> <button ng-if=\"vm.editing == true\" type=\"submit\" class=\"btn btn-danger\" ng-click=\"vm.deleteNewsItem()\">Delete</button></div></form></div></div></div>");
$templateCache.put("app/admin/sections/press-release/press-release-add-edit/press-release-add-edit.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>{{vm.editing == true ? \'Edit\' : \'Add\'}} Press Release</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"pressReleaseAddEditForm\" novalidate=\"\"><uib-tabset active=\"active\" class=\"aside-tabs\"><uib-tab index=\"0\"><uib-tab-heading>Details</uib-tab-heading><div class=\"aside-body aside-body--tab\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"title\">Press Release Details</label><div ng-class=\"{\'has-error\': hasError(pressReleaseAddEditForm.title)}\"><input type=\"text\" name=\"title\" id=\"title\" class=\"form-control input-lg\" placeholder=\"Title\" ng-model=\"vm.pressRelease.title\" maxlength=\"140\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(pressReleaseAddEditForm.title, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(pressReleaseAddEditForm.date)}\"><input bs-datepicker=\"\" type=\"text\" name=\"date\" id=\"date\" class=\"form-control input-lg\" placeholder=\"Date\" ng-model=\"vm.pressRelease.date\" required=\"\" data-arrow-behavior=\"picker\" data-autoclose=\"1\"> <span class=\"help-block\" ng-show=\"showError(pressReleaseAddEditForm.date, \'required\')\">This field is required</span></div></div><div class=\"form-group\"><div class=\"m-t\"><label>Body</label><trix-editor angular-trix=\"\" ng-if=\"true\" ng-model=\"vm.pressRelease.body\" required=\"\"></trix-editor></div></div><div class=\"form-group\"><div class=\"m-t\"><label for=\"title\">PDF File</label><div ng-if=\"vm.pressRelease.pdfUrl\"><input disabled=\"\" type=\"text\" name=\"pdfUrl\" id=\"pdfUrl\" class=\"form-control input-lg\" placeholder=\"Thumbnail URL\" ng-model=\"vm.pressRelease.pdfUrl\"> <button class=\"m-t btn btn-danger\" ng-click=\"vm.pressRelease.pdfUrl = null;\">Remove</button></div><input ng-if=\"!vm.pressRelease.pdfUrl\" class=\"m-t\" type=\"file\" ngf-select=\"\" ng-model=\"vm.pdfFile\" name=\"pdfFile\" accept=\"application/pdf\" ngf-max-size=\"2MB\" required=\"\" ngf-model-invalid=\"errorFile\"> <span class=\"m-t help-block\" ng-show=\"!vm.thumbnailFile && !vm.pressRelease.pdfUrl\">A PDF is required</span><div class=\"m-t-lg\" ng-if=\"vm.progress && vm.progress > 0\"><label>Upload Progress:</label><uib-progressbar class=\"m-t-xs\" value=\"vm.progress\"></uib-progressbar></div></div></div><div class=\"form-group\"><div class=\"m-t\"><label>Contact</label><trix-editor ng-if=\"true\" angular-trix=\"\" ng-model=\"vm.pressRelease.contactInfo\"></trix-editor></div></div><div class=\"form-group\"><div ng-if=\"vm.editing\" class=\"m-t\"><highlight-select highlight=\"vm.highlight\"></highlight-select></div></div><div class=\"form-group\"><div class=\"m-t\" ng-class=\"{\'has-error\': !vm.isTimeValid() }\"><label>Schedule for Posting</label><div class=\"row schedule-container\"><div class=\"col-md-6\"><input bs-datepicker=\"\" type=\"text\" name=\"releaseDate\" id=\"date\" class=\"form-control input-lg\" min-date=\"today\" placeholder=\"Release Date\" ng-model=\"vm.pressRelease.releaseDate\" data-arrow-behavior=\"picker\" data-autoclose=\"1\"></div><div class=\"col-md-6\" ng-if=\"vm.pressRelease.releaseDate\"><input type=\"text\" size=\"8\" class=\"form-control input-lg\" ng-model=\"vm.pressRelease.releaseDate\" data-time-format=\"h:mm a\" data-autoclose=\"1\" placeholder=\"Release Time\" data-minute-step=\"5\" data-round-display=\"true\" bs-timepicker=\"\"></div><div class=\"col-xs-12\"><span class=\"help-block\" ng-show=\"!vm.isTimeValid()\">The Release Date is invalid (must be at least {{ vm.getCurrentDate() | formatTime: true }})</span></div></div></div></div></div><div class=\"clearfix\"></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading>SEO Settings</uib-tab-heading><div class=\"aside-body aside-body--tab\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"title\">General</label><div ng-class=\"{\'has-error\': hasError(pressReleaseAddEditForm.metaTitle)}\"><input type=\"text\" name=\"metaTitle\" id=\"metaTitle\" class=\"form-control input-lg\" placeholder=\"Title\" ng-model=\"vm.pressRelease.metaTitle\" maxlength=\"65\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(pressReleaseAddEditForm.metaTitle, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(pressReleaseAddEditForm.metaSlug)}\"><input type=\"text\" name=\"metaSlug\" id=\"metaSlug\" class=\"form-control input-lg\" placeholder=\"Slug\" ng-model=\"vm.pressRelease.metaSlug\" maxlength=\"150\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(pressReleaseAddEditForm.metaSlug, \'required\')\">This field is required</span></div><div class=\"m-t\"><textarea name=\"metaDescription\" maxlength=\"165\" ng-model=\"vm.pressRelease.metaDescription\" id=\"metaDescription\" class=\"form-control input-lg\" placeholder=\"Description\">\n                                        </textarea></div></div></div><div class=\"clearfix\"></div></div></uib-tab></uib-tabset></form></div><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(pressReleaseAddEditForm)\" ng-click=\"vm.savePressRelease()\">{{vm.editing == true ? \'Update\' : \'Add\'}}</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button> <button ng-if=\"vm.editing == true\" type=\"submit\" class=\"btn btn-danger\" ng-click=\"vm.deletePressRelease()\">Delete</button></div></div></div>");
$templateCache.put("app/admin/sections/team-member/team-member-add-edit/team-member-add-edit.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>{{vm.editing == true ? \'Edit\' : \'Add\'}} Team Member</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"teamMemberAddEditForm\" novalidate=\"\"><div class=\"aside-body\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"name\">Team Member Details</label><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(teamMemberAddEditForm.name)}\"><input type=\"text\" name=\"name\" id=\"name\" class=\"form-control input-lg\" placeholder=\"Name\" ng-model=\"vm.teamMember.name\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(teamMemberAddEditForm.name, \'required\')\">This field is required</span></div></div><div class=\"form-group\"><div class=\"m-t\"><label for=\"name\">Team Member Image</label><div ng-if=\"vm.teamMember.imageUrl\"><input disabled=\"\" type=\"text\" name=\"imageUrl\" id=\"imageUrl\" class=\"form-control input-lg\" placeholder=\"Thumbnail URL\" ng-model=\"vm.teamMember.imageUrl\"> <img class=\"m-t img-responsive\" ng-src=\"{{vm.teamMember.imageUrl}}\"> <button class=\"m-t btn btn-danger\" ng-click=\"vm.teamMember.imageUrl = null;\">Remove</button></div><input ng-if=\"!vm.teamMember.imageUrl\" class=\"m-t\" type=\"file\" ngf-select=\"\" ng-model=\"vm.imageFile\" name=\"imageFile\" accept=\"image/*\" ngf-max-size=\"2MB\" required=\"\" ngf-model-invalid=\"errorFile\"> <span class=\"m-t help-block\" ng-show=\"!vm.imageFile && !vm.teamMember.imageUrl\">A image is required</span><div class=\"m-t-lg\" ng-if=\"vm.progress && vm.progress > 0\"><label>Upload Progress:</label><uib-progressbar class=\"m-t-xs\" value=\"vm.progress\"></uib-progressbar></div></div></div></div><div class=\"clearfix\"></div></div><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(teamMemberAddEditForm)\" ng-click=\"vm.saveTeamMember()\">{{vm.editing == true ? \'Update\' : \'Add\'}}</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button> <button ng-if=\"vm.editing == true\" type=\"submit\" class=\"btn btn-danger\" ng-click=\"vm.deleteTeamMember()\">Delete</button></div></form></div></div></div>");
$templateCache.put("app/admin/sections/user/user-add/user-add.view.html","<div class=\"aside admin view add\" tabindex=\"-1\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-heading\"><section class=\"panel panel-default panel-name\"><div class=\"panel-heading name\"><h2>Add User</h2></div></section></div><form class=\"form add\" role=\"form\" name=\"userAddForm\" novalidate=\"\"><div class=\"aside-body\"><div class=\"col-sm-10\"><div class=\"flash-message\" ng-if=\"flash\"><div class=\"alert alert-{{flash.type}}\" ng-bind=\"flash.message\"></div></div><div class=\"form-group info-admin\"><label for=\"fields\">User Information</label><p>Complete the fields provided to add the User. All fields are required.</p><div ng-class=\"{\'has-error\': hasError(userAddForm.username)}\"><input type=\"text\" name=\"username\" id=\"username\" class=\"form-control input-lg\" placeholder=\"Username\" ng-model=\"vm.user.username\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(userAddForm.username, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(userAddForm.name)}\"><input type=\"text\" name=\"name\" id=\"name\" class=\"form-control input-lg\" placeholder=\"First and Last Name\" ng-model=\"vm.user.name\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(userAddForm.name, \'required\')\">This field is required</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(userAddForm.email)}\"><input type=\"email\" name=\"email\" id=\"email\" class=\"form-control input-lg\" placeholder=\"Email\" ng-model=\"vm.user.email\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(userAddForm.email, \'required\')\">This field is required</span> <span class=\"help-block\" ng-show=\"showError(userAddForm.email, \'email\')\">Please enter a valid email</span></div><div class=\"m-t\" ng-class=\"{\'has-error\': hasError(userAddForm.password)}\"><input type=\"password\" name=\"password\" id=\"password\" class=\"form-control input-lg\" placeholder=\"Password\" ng-model=\"vm.user.password\" required=\"\"> <span class=\"help-block\" ng-show=\"showError(userAddForm.password, \'required\')\">This field is required</span></div></div></div></div><div class=\"aside-footer\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!canSave(userAddForm)\" ng-click=\"vm.addUser()\">Add</button> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"$hide()\">Close</button><div class=\"loadingdata\"><div ng-if=\"isDataLoading\"><div class=\"loadingimage\"></div></div></div></div></form></div></div></div>");}]);